/* eslint-disable */
import { OfferStatus } from '../models/offer.model';
import { Offers } from '../models/offers.model';
import { OfferType } from '../models/replacement.offer.model';
import { Description, Status } from '../models/service.model';
import { CompareType } from '../models/specification.model';

export const mockOffers: Offers = {
  offer: {
    offerReference: '205b8cb4-7169-4dec-95e7-f344f26bf6e7',
    offer_status: OfferStatus.AVAILABLE,
    number_of_replacements: 6,
    number_of_upgrades: 6,
    upsell_flag: true,
    rrp_flag: true,
    outstanding_dd_amount: 99,
    outstanding_dd_count: 12,
  },
  current_plan: {
    client_code: '00351',
    client_group_code: '00296',
    plan_category: 'S',
    plan_number: 'ORB0000150',
    company_code: 'D',
    scheme_code: 'T3F',
    reference_number: '0005123',
    dd_amount: 8.99,
    dd_details: {
      sort_code: '****01',
      account_number: '******90',
      name: 'J Smith',
      nom_pay_day: '04',
      payment_token: 'VU700292801340540',
    },
  },
  contact_details: {
    forename: 'SHABA',
    surname: 'MORETON-AAAQ',
    person_gid: '3697141',
  },
  delivery_address: {
    address_line_1: '28 HEPPLESTONE CLOSE',
    address_line_2: 'LONDON',
    address_line_3: 'LONDON',
    postal_code: 'SW15 5DE',
    country_code: 'GBR',
  },
  person_owner_eid: '3697141',
  current_item: {
    make: 'Bosch',
    model: 'WAN28080GB',
    colour: 'Silver',
    short_description: 'Bosch WAN28080GB Washing Machine',
    long_description: 'Bosch WAN28080GB Washing Machine Silver A+++ 7 1400',
    images: [
      {
        text: '',
        url: 'https://validatorimages.azureedge.net/large/2147012039.jpg',
      },
    ],
    compare_specs: [
      {
        name: 'Bluetooth',
        value: 'No',
      },
      {
        name: 'Construction',
        value: 'Freestanding',
      },
      {
        name: 'Delay Timer',
        value: 'Yes',
      },
      {
        name: 'Depth',
        value: '550',
      },
      {
        name: 'Drying Function',
        value: 'No',
      },
      {
        name: 'Energy Efficiency',
        value: 'A+++',
      },
      {
        name: 'Height',
        value: '848',
      },
      {
        name: 'Loading',
        value: 'Front Loader',
      },
      {
        name: 'Make',
        value: 'Bosch',
      },
      {
        name: 'ReleaseDate',
        value: 'Jul  1 2016 12:00AM',
      },
      {
        name: 'Spin Efficiency',
        value: 'B',
      },
      {
        name: 'Spin Speed',
        value: '1400',
      },
      {
        name: 'Type',
        value: 'Washing machine',
      },
      {
        name: 'Wash Capacity',
        value: '7',
      },
      {
        name: 'Wash Efficiency',
        value: 'A',
      },
      {
        name: 'Width',
        value: '598',
      },
      {
        name: 'WiFi',
        value: 'No',
      },
    ],
    purchase_price: 300,
    appliance_category: 'Washing Machine',
  },
  replacement_offers: [
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'BEKO',
      make: 'BEKO',
      model: 'WTG620M2W',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 1,
      upgrade_fee: 205,
      rrp: 215.42,
      article_id: 2146903247,
      appliance_category: 'Washing Machine',
      short_description: 'BEKO WTG620M2W Washing Machine',
      long_description: 'BEKO WTG620M2W Washing Machine White A+++ 6 1200',
      selected: true,
      supplier_name: 'RGB',
      cat_num: 'WTG620M2W',
      supplier_id: 6684,
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        // {
        //   name: 'Measurements',
        //   value: 'W100 x D200 x H300 mm'
        // },
        // {
        //   name: 'Wash capacity',
        //   value: '1 kg'
        // }
      ],
      services: [
        {
          cat_num: 'DELRGB',
          charge_type: 1,
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 0,
          charge_customer: false,
        },
        {
          cat_num: 'INSRGB',
          charge_type: 2,
          status: Status.C,
          description: Description.Installation,
          price_net: 16.666666,
          price_gross: 20,
          charge_customer: true,
        },
        {
          cat_num: 'REMOVALRGBWM',
          charge_type: 3,
          status: Status.C,
          description: Description.Disposal,
          price_net: 10,
          price_gross: 12,
          charge_customer: true,
        },
      ],
      // summary_specs: [
      //   'Slim depth',
      //   'Large porthole door',
      //   'Hand wash program',
      //   'Child safety lock'
      // ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/8d/7f/8d7f1746-55f1-441a-90fe-9f70ccac637a.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
          compare: CompareType.EQUIVALENT,
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '415',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '840',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Beko',
        },
        {
          name: 'ReleaseDate',
          value: 'Aug 30 2017 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '6',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Beko WTG620M2 washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '6 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '152 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '8799 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '62 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '77 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '77 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Washer Drum Capacity',
          value: '39 liters',
        },
        {
          name: 'Washing Efficiency',
          value: 'Class A',
        },
        {
          name: 'Programs Qty',
          value: '15',
        },
        {
          name: 'Safety Features',
          value:
            'Water overflow protection system, electromechanical door lock, ChildLock',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.78 kWh',
        },
        {
          name: 'Water Consumption per Cycle',
          value: '40 liters',
        },
        {
          name: 'Voltage',
          value: '230 V / 50 Hz',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '60 cm x 41.5 cm x 84 cm',
        },
        {
          name: 'Weight',
          value: '56 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Door Opening Angle',
          value: '170 degrees',
        },
        {
          name: 'Door Opening Diameter',
          value: '30 cm',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Material',
          value: 'Stainless steel',
        },
        {
          name: 'Average Cycle Time',
          value: '250 minutes',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '9 hours',
        },
        {
          name: 'Indicators',
          value: 'Wash progress indicator',
        },
        {
          name: 'Type',
          value: 'Digital',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Daily wash, half-load, quick wash, pre-wash, cotton, synthetics, hand wash, dark garments, Baby, drain + spin, cotton eco, rinse hold, extra rinse, rinse, mix, drum cleaning',
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '1550 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.25 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.75 W',
        },
        {
          name: 'Rated Current',
          value: '10 A',
        },
        {
          name: 'Width',
          value: '60 cm',
        },
        {
          name: 'Depth',
          value: '41.5 cm',
        },
        {
          name: 'Height',
          value: '84 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '65 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '46.5 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '88 cm',
        },
        {
          name: 'Weight (Shipping)',
          value: '57 kg',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'HOTP',
      make: 'Hotpoint',
      model: 'WMAQF641P',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 2,
      upgrade_fee: 0,
      rrp: 272.18,
      article_id: 2147265318,
      appliance_category: 'Washing Machine',
      short_description: 'Hotpoint WMAQF641P Washing Machine',
      long_description: 'Hotpoint WMAQF641P Washing Machine White A+ 6 1400',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'WMAQF641P',
      supplier_id: 6684,
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },

        {
          name: 'Energy efficiency',
          value: null,
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      services: [
        {
          cat_num: 'DELRGB',
          charge_type: 1,
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 0,
          charge_customer: false,
        },
        {
          cat_num: 'INSRGB',
          charge_type: 2,
          status: Status.C,
          description: Description.Installation,
          price_net: 16.666666,
          price_gross: 20,
          charge_customer: true,
        },
        {
          cat_num: 'REMOVALRGBWM',
          charge_type: 3,
          status: Status.C,
          description: Description.Disposal,
          price_net: 10,
          price_gross: 12,
          charge_customer: true,
        },
      ],
      summary_specs: [
        'Baby cycle',
        'Eco Tech',
        'Anti-stain technology',
        'Woolmark platinum care',
        'Anti-allergy program',
        'Fast wash programs',
        'Selectable child lock',
        'Delay start',
      ],
      images: [
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/cf/4b/cf4bf570-94c1-4a2e-b48e-51ebbc7ec7a0.jpg',
        },
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/b5/43/b5433160-b5fd-4079-841f-fdec33f0fc02.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/c3/2c/c32c3fc3-a211-4af6-bf17-c17528aaa39c.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'Yes',
          compare: CompareType.BETTER,
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '540',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Hotpoint',
        },
        {
          name: 'ReleaseDate',
          value: 'Jan 20 2014 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1400',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '6',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Hotpoint WMAQF 641P washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+',
        },
        {
          name: 'Loading Capacity',
          value: '6 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '196 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '8643 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1400 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '58 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '80 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '80 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '52 liters',
        },
        {
          name: 'Programs Qty',
          value: '16',
        },
        {
          name: 'Safety Features',
          value: 'Child security, water overflow protection system',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 54 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '66 kg',
        },
        {
          name: 'Manufacturer Warranty',
          value: '1 year',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Program Time Details',
          value: '195 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Type',
          value: 'Digital',
        },
        {
          name: 'Special Programs & Options',
          value: `Quick wash, Woolmark Platinum Care, Baby, Super Wash,
            anti-allergy, pause option, daily 30', eco wash`,
        },
        {
          name: 'Features',
          value:
            'Ecotech, anti-stain system, variable temperature, spin speed selection',
        },
        {
          name: 'Exterior Features',
          value: 'White door',
        },
        {
          name: 'Compliant Standards',
          value: 'Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '1.05 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '54 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '64 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '59 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '89 cm',
        },
        {
          name: 'Warranty',
          value: '1 year',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'AMIC',
      make: 'Amica',
      model: 'WME612',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 3,
      upgrade_fee: 50,
      rrp: 219.79,
      article_id: 2146846204,
      appliance_category: 'Washing Machine',
      short_description: 'Amica WME612 Washing Machine',
      long_description: 'Amica WME612 Washing Machine White A++ 6 1200',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'WME612',
      supplier_id: 6684,
      services: [],
      summary_specs: [
        'Variable spin speed',
        'Delay timer',
        'Child lockable control panel',
        'Anti-crease function',
      ],
      key_features: [],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/c8/bf/c8bf5e01-41cf-441a-ac3a-2e4b1f045471.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
          compare: CompareType.EQUIVALENT,
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '470',
        },
        {
          name: 'Energy Efficiency',
          value: 'A++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Amica',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '6',
        },
        {
          name: 'Wash Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Amica WME612 washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A++',
        },
        {
          name: 'Loading Capacity',
          value: '6 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '173 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '9240 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '59 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '76 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '76 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Programs Qty',
          value: '23',
        },
        {
          name: 'Safety Features',
          value: 'ChildLock',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.9 kWh',
        },
        {
          name: 'Water Consumption per Cycle',
          value: '48 liters',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Plug Type',
          value: 'British',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 47 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '54 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton Eco',
        },
        {
          name: 'Door Opening Diameter',
          value: '45 cm',
        },
        {
          name: 'Program Time Details',
          value: '239 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Material',
          value: 'Stainless steel',
        },
        {
          name: 'Control Location',
          value: 'Front panel',
        },
        {
          name: 'Timer Settings Features',
          value:
            'Program ending audible signal, 3 hours auto shut-off delay, 6 hours auto shut-off delay, signal on/off, 9 hours auto shut-off delay',
        },
        {
          name: 'Indicators',
          value: 'Closed door indicator, child security indicator',
        },
        {
          name: 'Special Programs & Options',
          value: `Pre-wash, delicate, cotton eco, drain, skip spin, extra rinse,
            spin only, delicate 30°, anti-crease at the end of cycle, Auto clean,
            rinse, pause option, cotton 20 °C, Express 15', synthetic 40 °C,
            synthetic 60 °C, cotton 40 °C, cotton 30 °C, cotton 60 °C, cotton 90 °C,
            cotton eco 60 °C, cotton cold, synthetic cold, drum cleaning, quick 30', daily 45'`,
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'Directive 2009/125/EC, Directive 1015/2010/EU, Directive 2010/30/EU, Directive 1061/2010/EU, EN 60456, RoHS 2011/65/EU, LVD 2014/35/EU, Directive 2009/125/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.9 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Max Power Consumption',
          value: '1950 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '1 W',
        },
        {
          name: 'Rated Current',
          value: '13 A',
        },
        {
          name: 'Cord Length',
          value: '1.5 m',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '47 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'HOTP',
      make: 'Hotpoint',
      model: 'WMEUF722P',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 4,
      upgrade_fee: 30.01,
      rrp: 272.8,
      article_id: 2146902655,
      appliance_category: 'Washing Machine',
      short_description: 'Hotpoint WMEUF722P Washing Machine',
      long_description: 'Hotpoint WMEUF722P Washing Machine White A++ 7 1200',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'WMEUF722P',
      supplier_id: 6684,
      services: [],
      summary_specs: [],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/a7/36/a7363592-3cd5-4e22-a555-42eb7501173a.jpg',
        },
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '540',
        },
        {
          name: 'Energy Efficiency',
          value: 'A++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Hotpoint',
        },
        {
          name: 'ReleaseDate',
          value: 'Jun  1 2017 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '7',
        },
        {
          name: 'Wash Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Hotpoint WMEUF 722P UK washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A++',
        },
        {
          name: 'Loading Capacity',
          value: '7 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '198 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '10630 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '58 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '77 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '77 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Washer Drum Capacity',
          value: '52 liters',
        },
        {
          name: 'Washing Efficiency',
          value: 'Class A',
        },
        {
          name: 'Safety Features',
          value: 'Anti-foam control',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '1.08 kWh',
        },
        {
          name: 'Water Consumption per Cycle',
          value: '52.5 liters',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Plug Type',
          value: 'British',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 54 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '65.8 kg',
        },
        {
          name: 'Manufacturer Warranty',
          value: '1 year',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton Eco',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '205 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Control Location',
          value: 'Front panel',
        },
        {
          name: 'Indicators',
          value: 'Time remaining indicator, wash progress indicator',
        },
        {
          name: 'Type',
          value: 'Digital',
        },
        {
          name: 'Special Programs & Options',
          value: `Bed & bath, delicate, cotton, synthetics, shirts,
            Baby, Woolmark, anti-stain program, drain + spin, whites, drain,
            favorite, skip spin, extra rinse, rinse + spin, quick 60',
            wool 40°, rinse, cotton 20 °C, cotton eco 40 °C, cotton eco 60 °C,
            Anti Allergy Plus, quick 30'`,
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable front feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'Directive 2010/30/EC, Directive 1061/2010/EU, WEEE 2012/19/EU, EMC 2014/30/EU, LVD 2014/35/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '1.08 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '1850 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Rated Current',
          value: '13 A',
        },
        {
          name: 'Cord Length',
          value: '1.2 m',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '54 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Warranty',
          value: '1 year',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'INDE',
      make: 'Indesit',
      model: 'EWD71252W',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 5,
      upgrade_fee: 295,
      rrp: 249.99,
      article_id: 2147112660,
      appliance_category: 'Washing Machine',
      short_description: 'Indesit EWD71252W Washing Machine',
      long_description: 'Indesit EWD71252W Washing Machine White A++ 7 1200',
      selected: false,
      supplier_name: 'AO Retail',
      cat_num: 'EWD71252W',
      supplier_id: 6680,
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      services: [
        {
          cat_num: 'DELSTD',
          charge_type: 1,
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 0,
          charge_customer: false,
        },
        {
          cat_num: 'AOINDE',
          charge_type: 2,
          status: Status.C,
          description: Description.Installation,
          price_net: 16.658333,
          price_gross: 19.99,
          charge_customer: true,
        },
        {
          cat_num: 'REMAO',
          charge_type: 3,
          status: Status.C,
          description: Description.Disposal,
          price_net: 8.325,
          price_gross: 9.99,
          charge_customer: true,
        },
      ],
      summary_specs: [
        'With the Eco Time option there is no need to wait for a full load, this option is to use whenever you need to wash a smaller load and quickly',
        'Energy Saver option, on cotton, synthetic and jeans wash program, allows you to achieve optimal wash results with energy savings of up to 70% (compared to cotton wash cycles 30°C)',
        'Indesit offers a wide number of special programs to wash effectively different kinds of fabric according to your needs',
        'The sport cycles specifically designed by Indesit to take care of your sport garments',
        'You can delay the program for up to 24 hours according to your needs',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/19/96/1996e802-b229-4e07-8c6d-4e776675d320.jpg',
        },
        {
          text: 'Left-angle',
          url: 'https://cdn.cnetcontent.com/d8/7c/d87c1c38-8b70-47f4-b1cb-133ce40d9383.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/45/e0/45e0b648-6ccf-4553-97b3-55771ba9067d.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/65/6d/656d219b-0b1c-46c6-8ea5-8d229a0ee299.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/fc/b6/fcb6a161-ae16-4a69-8691-f37878fb303f.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '535',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Indesit',
        },
        {
          name: 'ReleaseDate',
          value: 'Oct  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '7',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Indesit Ecotime EWD 71252 W washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A++',
        },
        {
          name: 'Loading Capacity',
          value: '7 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '197 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '10600 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: '1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '60 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '75 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '75 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding (can be integrated)',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '52 liters',
        },
        {
          name: 'Programs Qty',
          value: '16',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '1.096 kWh',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 53.5 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '66.5 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Average Cycle Time',
          value: '205 minutes',
        },
        {
          name: 'Timer Settings Features',
          value: '24 hours start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '24 hours',
        },
        {
          name: 'Indicators',
          value: 'Wash progress indicator',
        },
        {
          name: 'Type',
          value: 'LED display',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Wool, jeans, outerwear, sports light, sports intensive, Zone 20°, Energy Saver option, TimeSaver',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '53.5 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '64.5 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '59 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '89 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'ZANU',
      make: 'Zanussi',
      model: 'ZWF81243',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 6,
      upgrade_fee: 99,
      rrp: 283.5,
      article_id: 2147158145,
      appliance_category: 'Washing Machine',
      short_description: 'Zanussi ZWF81243 Washing Machine',
      long_description: 'Zanussi ZWF81243 Washing Machine White A+++ 8 1200',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'ZWF81243',
      supplier_id: 6684,
      services: [],
      summary_specs: [
        'Saves you time, reducing energy and water consumption',
        'Wash your clothes in half the time',
        'The washing machine that runs whenever it suits you best',
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/fa/04/fa04df13-4924-40df-91f2-7ccb193162ee.jpg',
        },
        {
          text: 'Back',
          url: 'https://cdn.cnetcontent.com/31/9a/319a7bb5-dcf4-4ef2-953b-eacbb77ac2d3.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/fa/6b/fa6bc28e-249c-43b5-a15c-a063a09b372a.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/65/15/65156b13-ab61-4ff9-bf4d-e9746cb3d288.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '559',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Zanussi',
        },
        {
          name: 'ReleaseDate',
          value: 'Mar  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '8',
        },
        {
          name: 'Wash Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Zanussi LINDO100E ZWF81243WE washing machine - front loading - freestanding',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '8 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '190 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '9999 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '59 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '77 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '77 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Washer Drum Capacity',
          value: '54 liters',
        },
        {
          name: 'Program Optimization',
          value: 'Fuzzy Logic',
        },
        {
          name: 'Safety Features',
          value: 'ChildLock, Anti-flood protection',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '1.03 kWh',
        },
        {
          name: 'Water Consumption per Cycle',
          value: '48 liters',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.7 cm x 64.3 cm x 85.4 cm',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton Eco',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '5 min',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '210 min - washing - full load - 60 °C',
        },
        {
          name: 'Control Location',
          value: 'Front panel',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay, program ending audible signal, FlexiTimer',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '9 hours',
        },
        {
          name: 'Indicators',
          value:
            'Time remaining indicator, lock indicator, wash progress indicator',
        },
        {
          name: 'Type',
          value: 'Digital',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Quick wash, delicate, cotton, synthetics, dark garments, jeans, drain, Easy Iron, 20 min - 3 kg, rinse, Mix 20, Wool Plus, 30 min 30°, spin, cotton economy, AutoSense',
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'IPX4, Directive 2010/30/EC, Directive 2009/125/EC, Directive 1061/2010/EU, Directive 1015/2010/EC',
        },
        {
          name: 'Energy Consumption Details',
          value: '1.03 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '1850 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.48 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.48 W',
        },
        {
          name: 'Rated Current',
          value: '13 A',
        },
        {
          name: 'Cord Length',
          value: '1.4 m',
        },
        {
          name: 'Width',
          value: '59.7 cm',
        },
        {
          name: 'Depth',
          value: '64.3 cm',
        },
        {
          name: 'Height',
          value: '85.4 cm',
        },
        {
          name: 'Dimensions Details',
          value: 'Depth without door 60.7 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'ZANU',
      make: 'Zanussi',
      model: 'ZWF71340W',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 7,
      upgrade_fee: 55,
      rrp: 0,
      article_id: 2147173727,
      appliance_category: 'Washing Machine',
      short_description: 'Zanussi ZWF71340W Washing Machine',
      long_description: 'Zanussi ZWF71340W Washing Machine White A+++ 7 1300',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'ZWF71340W',
      supplier_id: 6684,
      services: [],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      summary_specs: [
        'Clean clothes in just 30 minutes',
        'Quick wash in 30 minutes - easy does it',
        'Always keeps the detergent dispenser clean',
        'The washing machine that runs whenever it suits you best',
        'Wash your clothes in half the time',
        'Get perfectly clean clothes, each and every wash load',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/cb/43/cb43905b-83c2-43a6-b149-ba9a1baae5b2.jpg',
        },
        {
          text: 'Back',
          url: 'https://cdn.cnetcontent.com/69/5b/695b1875-4d18-434e-88a0-bf51adbdab42.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/38/84/38841470-a573-4d3d-aec1-3b41da6e073a.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/e3/1e/e31e9b26-45fd-4ada-b882-3e6a423ed7f7.jpg',
        },
        {
          text: 'Left-angle',
          url: 'https://cdn.cnetcontent.com/03/c0/03c048e9-4a7f-4047-b92f-612f9decece9.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '514',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Zanussi',
        },
        {
          name: 'ReleaseDate',
          value: 'Mar  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'A',
        },
        {
          name: 'Spin Speed',
          value: '1300',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '7',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Zanussi LINDO100 ZWF71340W washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '7 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '171 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '9499 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1300 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '52%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '58 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '78 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '78 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washing Efficiency',
          value: 'Class A',
        },
        {
          name: 'Programs Qty',
          value: '14',
        },
        {
          name: 'Program Optimization',
          value: 'Fuzzy Logic',
        },
        {
          name: 'Safety Features',
          value: 'ChildLock, Anti-flood protection',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.92 kWh',
        },
        {
          name: 'Voltage',
          value: '230 - 240 V / 50 Hz',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '60 cm x 55.9 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '65.4 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '5 min',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '250 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Average Cycle Time',
          value: '250 minutes',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '9 hours',
        },
        {
          name: 'Special Programs & Options',
          value: `Quick wash, delicate, cold wash, cotton, synthetics, dark garments,
            hand wash/wool, jeans, quick 30, drain, Mini 30, extra rinse,
            Easy Iron, quick 20, rinse, pause option, Mix 20, Wool Plus,
            30 min 30°, 20' refresh, spin, cotton economy, TimeSaver`,
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'IPX4, Directive 2010/30/EC, Directive 2009/125/EC, Directive 1015/2010/EU, Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.92 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '2200 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.48 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.48 W',
        },
        {
          name: 'Rated Current',
          value: '13 A',
        },
        {
          name: 'Width',
          value: '60 cm',
        },
        {
          name: 'Depth',
          value: '55.9 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'INDE',
      make: 'Indesit',
      model: 'EWD81482W',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 8,
      upgrade_fee: 0,
      rrp: 277.55,
      article_id: 2147126935,
      appliance_category: 'Washing Machine',
      short_description: 'Indesit EWD81482W Washing Machine',
      long_description: 'Indesit EWD81482W Washing Machine White A++ 8 1400',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'EWD81482W',
      supplier_id: 6684,
      services: [],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      summary_specs: [
        'With the Eco Time option there is no need to wait for a full load, this option is to use whenever you need to wash a smaller load and quickly',
        'Energy Saver option, on cotton, synthetic and jeans wash program, allows you to achieve optimal wash results with energy savings of up to 70% (compared to cotton wash cycles 30°C)',
        'Indesit offers a wide number of special programs to wash effectively different kinds of fabric according to your needs',
        'The sport cycles specifically designed by Indesit to take care of your sport garments',
        'You can delay the program for up to 24 hours according to your needs',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/e2/29/e229cf2c-5ca2-4cbd-83ec-0628e4f9f9e6.jpg',
        },
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/c4/37/c4374bd7-7c68-4099-a02e-9e3acc17b02a.jpg',
        },
        {
          text: 'Left-angle',
          url: 'https://cdn.cnetcontent.com/9b/2e/9b2e2cef-0149-4e04-a803-956d1866d961.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/23/e2/23e2fb18-6335-4fbf-a38a-3d33fafdd104.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/ca/5e/ca5e8b01-2215-4f11-b75e-55696d238c5a.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '600',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Indesit',
        },
        {
          name: 'ReleaseDate',
          value: 'Jun  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1400',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '8',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Indesit Ecotime EWD 81482 W washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A++',
        },
        {
          name: 'Loading Capacity',
          value: '8 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '220 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '11594 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: '1400 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '50 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '78 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '78 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding (can be integrated)',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '62 liters',
        },
        {
          name: 'Programs Qty',
          value: '16',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '1.201 kWh',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 60 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '73.4 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Average Cycle Time',
          value: '215 minutes',
        },
        {
          name: 'Timer Settings Features',
          value: '24 hours start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '24 hours',
        },
        {
          name: 'Indicators',
          value: 'Wash progress indicator',
        },
        {
          name: 'Type',
          value: 'LED display',
        },
        {
          name: 'Special Programs & Options',
          value: 'Wool, sportswear, outerwear, Energy Saver option, TimeSaver',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '60 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '64.5 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '65.5 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '89 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'ZANU',
      make: 'Zanussi',
      model: 'ZWF81443W',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 9,
      upgrade_fee: 0,
      rrp: 295.56,
      article_id: 2147135799,
      appliance_category: 'Washing Machine',
      short_description: 'Zanussi ZWF81443W Washing Machine',
      long_description: 'Zanussi ZWF81443W Washing Machine White A+++ 8 1400',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'ZWF81443W',
      supplier_id: 6684,
      services: [
        {
          cat_num: 'DELRGB',
          charge_type: 1,
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 30.99,
          charge_customer: true,
        },
        {
          cat_num: 'INSRGB',
          charge_type: 2,
          status: Status.C,
          description: Description.Installation,
          price_net: 16.666666,
          price_gross: 20,
          charge_customer: true,
        },
        {
          cat_num: 'REMOVALRGBWM',
          charge_type: 3,
          status: Status.C,
          description: Description.Disposal,
          price_net: 10,
          price_gross: 12,
          charge_customer: true,
        },
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },

        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      summary_specs: [
        'Quick wash in 30 minutes - easy does it',
        'Always keeps the detergent dispenser clean',
        'The washing machine that runs whenever it suits you best',
        'Wash your clothes in half the time',
        'Get perfectly clean clothes, each and every wash load',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/ee/63/ee63be0a-f876-4902-bda2-37353c960fa6.jpg',
        },
        {
          text: 'Back',
          url: 'https://cdn.cnetcontent.com/69/03/69039418-59ce-4777-940e-eb32db340611.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/9c/3a/9c3aec14-b3e0-48b8-9505-f131676f565b.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/39/6f/396f03c7-e103-48bf-97e7-d8ce82fcaa7a.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/a2/c3/a2c3ccdb-4cc2-4201-bda9-ce8ae667f32d.jpg',
        },
        {
          text: 'Left-angle',
          url: 'https://cdn.cnetcontent.com/7e/30/7e307aaf-1eab-454f-bba7-6bd52607bc18.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '559',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Zanussi',
        },
        {
          name: 'ReleaseDate',
          value: 'Mar  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1400',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '8',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Zanussi LINDO100 ZWF81443W washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '8 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '190 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '9999 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1400 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '52%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '58 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '78 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '78 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Safety Features',
          value: 'Child security, Aqua Control',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.96 kWh',
        },
        {
          name: 'Voltage',
          value: '230 V',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '60 cm x 57.8 cm x 85 cm',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '5 min',
        },
        {
          name: 'Program Time Details',
          value: '244 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Features',
          value: 'GentleCare drum',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '20 hours',
        },
        {
          name: 'Indicators',
          value: 'Time remaining indicator',
        },
        {
          name: 'Type',
          value: 'LCD display',
        },
        {
          name: 'Special Programs & Options',
          value: `Quick wash, delicate, hand wash, easy care, hand wash/silk,
            color wash, drain + spin, hand wash/wool, jeans, cotton eco,
            drain, extra rinse, Easy Iron, 30 min - 3 kg, hot, Mix 20, 20'
            refresh, QuickStart 30'@30°, Down Wear, short option, AutoSense`,
        },
        {
          name: 'Compliant Standards',
          value: 'Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.96 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '2200 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.75 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.48 W',
        },
        {
          name: 'Rated Current',
          value: '10 A',
        },
        {
          name: 'Width',
          value: '60 cm',
        },
        {
          name: 'Depth',
          value: '57.8 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 24,
      manuf_code: 'BOSC',
      make: 'Bosch',
      model: 'WAW32450GB_WH',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 10,
      upgrade_fee: 0,
      rrp: 600,
      article_id: 2146926548,
      appliance_category: 'Washing Machine',
      short_description: 'Bosch WAW32450GB_WH Washing Machine',
      long_description: 'Bosch WAW32450GB_WH Washing Machine White A+++ 9 1600',
      selected: false,
      supplier_name: 'AO Retail',
      cat_num: 'WAW32450GB_WH',
      supplier_id: 6680,
      services: [],
      summary_specs: [
        'EcoSilence Drive: extremely energy-efficient and quiet in operation with an especially long life',
        'Energy efficiency class A+++',
        'Allergy+ : specially developed for the needs of allergy sufferers',
        'ActiveWater: reduces water consumption and costs thanks to the sensor-controlled, stepless automatic load adjustment system',
        'VarioPerfect: takes 65% less time or uses 50% less energy - delivers total flexibility',
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },

        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      images: [
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/00/65/006563b7-e11a-473e-9120-6c9b6b0e2449.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/af/7a/af7a7d40-474c-477f-9096-ac67b0ee433e.jpg',
        },
        {
          text: 'Ports / controls',
          url: 'https://cdn.cnetcontent.com/9a/f1/9af193de-0742-4142-a7f6-e211d8182a9e.jpg',
        },
        {
          text: 'Ports / controls',
          url: 'https://cdn.cnetcontent.com/43/9d/439d4926-2e30-4a22-b911-7f3b28e4e73e.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '590',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '848',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Bosch',
        },
        {
          name: 'ReleaseDate',
          value: 'May  1 2017 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'A',
        },
        {
          name: 'Spin Speed',
          value: '1600',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '9',
        },
        {
          name: 'Wash Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Width',
          value: '598',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Bosch Serie | 8 WAW32450GB washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '9 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '152 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '11220 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class A',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1552 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '44%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '47 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '73 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '73 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding (can be integrated)',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Washer Drum Capacity',
          value: '70 liters',
        },
        {
          name: 'Safety Features',
          value:
            'AquaStop leak protection, water protection system, ChildLock, anti-foam control',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.92 kWh',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Plug Type',
          value: 'British',
        },
        {
          name: 'Sound Package',
          value: 'EcoSilence Drive',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.8 cm x 59 cm x 84.8 cm',
        },
        {
          name: 'Weight',
          value: '82 kg',
        },
        {
          name: 'Warranty Details',
          value: '10-year motor warranty',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton + EcoPerfect',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '15 min',
        },
        {
          name: 'Installation Type',
          value: 'Built under',
        },
        {
          name: 'Door Opening Angle',
          value: '171 degrees',
        },
        {
          name: 'Door Opening Diameter',
          value: '32 cm',
        },
        {
          name: 'Door Hinge',
          value: 'Left',
        },
        {
          name: 'Vibration Reduction',
          value: 'Yes',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '275 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Features',
          value: 'waveDrum',
        },
        {
          name: 'Control Location',
          value: 'Front panel',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay, program ending audible signal',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '24 hours',
        },
        {
          name: 'Indicators',
          value:
            'End of cycle, time remaining indicator, wash progress indicator',
        },
        {
          name: 'Type',
          value: 'LED display',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Quick wash, pre-wash, wool, cotton, hand wash, delicate/silk, easy care, SpeedPerfect, dark garments, shirts, sportswear, whites, hygiene, cotton eco, drain, mixed load, skip spin, Easy Iron, rinse + spin, ecoPerfect, Super Quick 15, reduced ironing, pause option, Allergy Plus, Aquaplus, varioPerfect',
        },
        {
          name: 'Interior Light',
          value: 'Yes',
        },
        {
          name: 'Customizable Features',
          value: 'Left door hinge',
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'VDE, Directive 2010/30/EC, Directive 1015/2010/EU, Directive 1061/2010/EU, WEEE 2012/19/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.92 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Max Power Consumption',
          value: '2300 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.12 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.43 W',
        },
        {
          name: 'Rated Current',
          value: '10 A',
        },
        {
          name: 'Cord Length',
          value: '1.75 m',
        },
        {
          name: 'Width',
          value: '59.8 cm',
        },
        {
          name: 'Depth',
          value: '59 cm',
        },
        {
          name: 'Height',
          value: '84.8 cm',
        },
        {
          name: 'Dimensions Details',
          value: 'Depth with door open 90° 106.3 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'HOTP',
      make: 'Hotpoint',
      model: 'RPD10657J',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 11,
      upgrade_fee: 0,
      rrp: 458.99,
      article_id: 2147136292,
      appliance_category: 'Washing Machine',
      short_description: 'Hotpoint RPD10657J Washing Machine',
      long_description: 'Hotpoint RPD10657J Washing Machine White A+++ 10 1600',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'RPD10657J',
      supplier_id: 6684,
      services: [],
      summary_specs: [
        'Direct injection',
        'Super silent',
        'Steam technology',
        'Anti-stain Turbo 45',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/04/0b/040bdd21-53bd-4e20-b42a-668f6fc2e61f.jpg',
        },
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/2f/3f/2f3fb8a9-178f-4725-a33b-84f4e5fcfdb3.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/ca/3d/ca3d8354-7336-47a3-b10e-633e637875c1.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/7a/2c/7a2c0a7a-53c5-4cbb-9e67-a9af73643791.jpg',
        },
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/ca/ec/caecf49f-2360-4662-8810-76009bf94862.jpg',
        },
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/36/87/3687f778-8262-4bc9-80ef-a17e7c44e4df.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/fa/62/fa62e079-b264-4f6d-a552-5bfcb84dfac5.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/81/31/8131b85d-d1a3-485f-ab6d-73a61ae5d1f4.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/5f/74/5f747ff1-b009-419c-8322-7b8bdf121585.jpg',
        },
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },

        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '605',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Hotpoint',
        },
        {
          name: 'ReleaseDate',
          value: 'Mar  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'A',
        },
        {
          name: 'Spin Speed',
          value: '1600',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '10',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Hotpoint Ultima S-Line RPD 10657 JX washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '10 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '190 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '12810 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class A',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1600 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '44%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '56 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '78 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '78 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '71 liters',
        },
        {
          name: 'Programs Qty',
          value: '16',
        },
        {
          name: 'Safety Features',
          value: 'Water overflow protection system, control lock, ChildLock',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.973 kWh',
        },
        {
          name: 'Sound Package',
          value: 'SuperSilent',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 60.5 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '75 kg',
        },
        {
          name: 'Manufacturer Warranty',
          value: '1 year',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Program Time Details',
          value: '220 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Indicators',
          value:
            'Time remaining indicator, closed door indicator, wash progress',
        },
        {
          name: 'Type',
          value: 'LCD display',
        },
        {
          name: 'Special Programs & Options',
          value: `Daily wash, bed & bath, quick wash, wool, cotton,
            synthetics, Woolmark Platinum Care, dark garments,
            shirts, Baby, anti-stain program, drain + spin, whites, duvet,
            quick 30, drain, Super Wash, anti-allergy, color wash 40°, steam hygiene,
            rinse, pause option, cotton eco 40 °C, cotton eco 60 °C,
            Anti Allergy Plus, ultra delicate, Anti Allergy delicate 40°,
            Anti-stain Power 20°, Anti-stain Turbo 45°, mix 30'`,
        },
        {
          name: 'Compliant Standards',
          value:
            'BS 5733, Directive 2004/108/EC, Directive 2006/95/EC, Directive 1015/2010/EU, Directive 2012/19/EU, Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.973 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '60.5 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '64 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '65 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '89 cm',
        },
        {
          name: 'Warranty',
          value: '1 year',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 24,
      manuf_code: 'BOSC',
      make: 'BOSCH',
      model: 'WAW32560GB',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 12,
      upgrade_fee: 0,
      rrp: 808.03,
      article_id: 2147229481,
      appliance_category: 'Washing Machine',
      short_description: 'BOSCH WAW32560GB Washing Machine',
      long_description: 'BOSCH WAW32560GB Washing Machine White A+++ 9 1600',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'WAW32560GB',
      supplier_id: 6684,
      services: [],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      summary_specs: [
        'EcoSilence Drive: extremely energy-efficient and quiet in operation',
        'Consumption indication: easy operation and indication of energy and water consumption',
        'AutoStain: removes the four most common stains',
        'Energy efficiency class A+++: more efficient',
        'DrumClean with reminder function: program for cleaning and maintaining the drum',
        'Cottons 60 Eco and Cottons 40 Eco: the most efficient programs in terms of combined energy and water consumption',
        'VarioPerfect: speed or energy efficiency with perfect wash performance every time',
        'ActiveWater: water management system',
        'AntiVibration design - for more stability and quietness',
        'Consumption indication: information about energy and water consumption',
        'Large LED display for program status indication, temperature selection, spin speed, remaining time',
        '24 h end time delay, stain selection and consumption indication',
        'Control dial with integrated On/Off mode',
        'Reload facility',
        'Drum interior light',
        'Self-cleaning detergent drawer',
        'WaveDrum: gentle and efficient washing',
        'Sound insulation by additional noise reduction material',
        'Child lock',
        'Buzzer',
      ],
      images: [
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/fe/eb/feebc34f-1636-4828-bde0-b36269913563.jpg',
        },
        {
          text: 'Right side',
          url: 'https://cdn.cnetcontent.com/de/65/de657192-67af-4087-aaf7-a7742b749e36.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/df/62/df6292ff-5625-4ee9-98d9-f220c05f4f0a.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '590',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '845',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Bosch',
        },
        {
          name: 'ReleaseDate',
          value: 'Jun  1 2014 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'A',
        },
        {
          name: 'Spin Speed',
          value: '1600',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '9',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Bosch Serie | 8 Logixx WAW32560GB washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++ -30%',
        },
        {
          name: 'Loading Capacity',
          value: '9 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '152 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '11220 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class A',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1552 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '44%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '47 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '73 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '73 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding (can be integrated)',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '65 liters',
        },
        {
          name: 'Washing Efficiency',
          value: 'Class A',
        },
        {
          name: 'Safety Features',
          value: 'Child security, water protection system',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Plug Type',
          value: 'British',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '60 cm x 59 cm x 84.5 cm',
        },
        {
          name: 'Weight',
          value: '80 kg',
        },
        {
          name: 'Manufacturer Warranty',
          value: '2 years',
        },
        {
          name: 'Warranty Details',
          value: '10-year motor warranty',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton + EcoPerfect',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '15 min',
        },
        {
          name: 'Installation Type',
          value: 'Built under',
        },
        {
          name: 'Door Opening Angle',
          value: '171 degrees',
        },
        {
          name: 'Door Opening Diameter',
          value: '32 cm',
        },
        {
          name: 'Vibration Reduction',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '275 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Material',
          value: 'Stainless steel',
        },
        {
          name: 'Drum Features',
          value: 'waveDrum, drum light',
        },
        {
          name: 'Timer Settings Features',
          value:
            'Start timer delay, program ending audible signal, countdown timer',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '24 hours',
        },
        {
          name: 'Indicators',
          value:
            'End of cycle, time remaining indicator, water temperature indicator, wash progress indicator, drum cleaning indicator, consumption indicator',
        },
        {
          name: 'Type',
          value: 'LED display',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Pre-wash, wool, cold wash, cotton, hand wash, easy care, SpeedPerfect, shirts, sportswear, duvet, drain, mixed load, skip spin, Easy Iron, rinse + spin, ecoPerfect, Night Wash, Super Quick 15, delicate 30°, reduced ironing, pause option, Allergy Plus, auto stains removal, drum cleaning, Aquaplus, varioPerfect',
        },
        {
          name: 'Interior Light',
          value: 'Yes',
        },
        {
          name: 'Features',
          value:
            'EcoSilence Drive motor, VarioPerfect option, ActiveWater system, Aqua Plus, autoStain Removal System (ASR), reload facility, self-cleaning detergent drawer, AntiVibration Design, variable temperature, balance control, foam control, DrumClean with reminder function',
        },
        {
          name: 'Exterior Features',
          value:
            'White control panel, left hinged, white satin aluminum door rim',
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value: 'VDE, Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.92 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Max Power Consumption',
          value: '2300 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.12 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.43 W',
        },
        {
          name: 'Cord Length',
          value: '1.75 m',
        },
        {
          name: 'Width',
          value: '60 cm',
        },
        {
          name: 'Depth',
          value: '59 cm',
        },
        {
          name: 'Height',
          value: '84.5 cm',
        },
        {
          name: 'Weight (Shipping)',
          value: '81 kg',
        },
        {
          name: 'Warranty',
          value: '2 years',
        },
      ],
    },
  ],
};

export const mockOffersUnique: Offers = {
  offer: {
    offerReference: '205b8cb4-7169-4dec-95e7-f344f26bf6e7',
    offer_status: OfferStatus.AVAILABLE,
    number_of_replacements: 6,
    number_of_upgrades: 6,
    upsell_flag: true,
    rrp_flag: true,
    outstanding_dd_amount: 99,
    outstanding_dd_count: 12,
  },
  current_plan: {
    client_code: '00351',
    client_group_code: '00296',
    plan_category: 'S',
    plan_number: 'ORB0000150',
    company_code: 'D',
    scheme_code: 'T3F',
    reference_number: '0005123',
    dd_amount: 8.99,
    dd_details: {
      sort_code: '****01',
      account_number: '******90',
      name: 'J Smith',
      nom_pay_day: '04',
      payment_token: 'VU700292801340540',
    },
  },
  contact_details: {
    forename: 'SHABA',
    surname: 'MORETON-AAAQ',
    person_gid: '3697141',
  },
  delivery_address: {
    address_line_1: '28 HEPPLESTONE CLOSE',
    address_line_2: 'LONDON',
    address_line_3: 'LONDON',
    postal_code: 'SW15 5DE',
    country_code: 'GBR',
  },
  person_owner_eid: '3697141',
  current_item: {
    make: 'Bosch',
    model: 'WAN28080GB',
    colour: 'Silver',
    short_description: 'Bosch WAN28080GB Washing Machine',
    long_description: 'Bosch WAN28080GB Washing Machine Silver A+++ 7 1400',
    images: [
      {
        text: '',
        url: 'https://validatorimages.azureedge.net/large/2147012039.jpg',
      },
    ],
    compare_specs: [
      {
        name: 'Bluetooth',
        value: 'No',
      },
      {
        name: 'Construction',
        value: 'Freestanding',
      },
      {
        name: 'Delay Timer',
        value: 'Yes',
      },
      {
        name: 'Depth',
        value: '550',
      },
      {
        name: 'Drying Function',
        value: 'No',
      },
      {
        name: 'Energy Efficiency',
        value: 'A+++',
      },
      {
        name: 'Height',
        value: '848',
      },
      {
        name: 'Loading',
        value: 'Front Loader',
      },
      {
        name: 'Make',
        value: 'Bosch',
      },
      {
        name: 'ReleaseDate',
        value: 'Jul  1 2016 12:00AM',
      },
      {
        name: 'Spin Efficiency',
        value: 'B',
      },
      {
        name: 'Spin Speed',
        value: '1400',
      },
      {
        name: 'Type',
        value: 'Washing machine',
      },
      {
        name: 'Wash Capacity',
        value: '7',
      },
      {
        name: 'Wash Efficiency',
        value: 'A',
      },
      {
        name: 'Width',
        value: '598',
      },
      {
        name: 'WiFi',
        value: 'No',
      },
    ],
    purchase_price: 300,
    appliance_category: 'Washing Machine',
  },
  replacement_offers: [
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'BEKO',
      make: 'BEKO',
      model: 'WTG620M2W',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 1,
      upgrade_fee: 205,
      rrp: 215.42,
      article_id: 2146903247,
      appliance_category: 'Washing Machine',
      short_description: 'BEKO WTG620M2W Washing Machine',
      long_description: 'BEKO WTG620M2W Washing Machine White A+++ 6 1200',
      selected: true,
      supplier_name: 'RGB',
      uniqueId: '0/2146903247',
      cat_num: 'WTG620M2W',
      supplier_id: 6684,
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        // {
        //   name: 'Measurements',
        //   value: 'W100 x D200 x H300 mm'
        // },
        // {
        //   name: 'Wash capacity',
        //   value: '1 kg'
        // }
      ],
      services: [
        {
          cat_num: 'DELRGB',
          charge_type: 1,
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 0,
          charge_customer: false,
        },
        {
          cat_num: 'INSRGB',
          charge_type: 2,
          status: Status.C,
          description: Description.Installation,
          price_net: 16.666666,
          price_gross: 20,
          charge_customer: true,
        },
        {
          cat_num: 'REMOVALRGBWM',
          charge_type: 3,
          status: Status.C,
          description: Description.Disposal,
          price_net: 10,
          price_gross: 12,
          charge_customer: true,
        },
      ],
      // summary_specs: [
      //   'Slim depth',
      //   'Large porthole door',
      //   'Hand wash program',
      //   'Child safety lock'
      // ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/8d/7f/8d7f1746-55f1-441a-90fe-9f70ccac637a.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
          compare: CompareType.EQUIVALENT,
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '415',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '840',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Beko',
        },
        {
          name: 'ReleaseDate',
          value: 'Aug 30 2017 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '6',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Beko WTG620M2 washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '6 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '152 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '8799 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '62 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '77 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '77 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Washer Drum Capacity',
          value: '39 liters',
        },
        {
          name: 'Washing Efficiency',
          value: 'Class A',
        },
        {
          name: 'Programs Qty',
          value: '15',
        },
        {
          name: 'Safety Features',
          value:
            'Water overflow protection system, electromechanical door lock, ChildLock',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.78 kWh',
        },
        {
          name: 'Water Consumption per Cycle',
          value: '40 liters',
        },
        {
          name: 'Voltage',
          value: '230 V / 50 Hz',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '60 cm x 41.5 cm x 84 cm',
        },
        {
          name: 'Weight',
          value: '56 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Door Opening Angle',
          value: '170 degrees',
        },
        {
          name: 'Door Opening Diameter',
          value: '30 cm',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Material',
          value: 'Stainless steel',
        },
        {
          name: 'Average Cycle Time',
          value: '250 minutes',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '9 hours',
        },
        {
          name: 'Indicators',
          value: 'Wash progress indicator',
        },
        {
          name: 'Type',
          value: 'Digital',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Daily wash, half-load, quick wash, pre-wash, cotton, synthetics, hand wash, dark garments, Baby, drain + spin, cotton eco, rinse hold, extra rinse, rinse, mix, drum cleaning',
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '1550 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.25 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.75 W',
        },
        {
          name: 'Rated Current',
          value: '10 A',
        },
        {
          name: 'Width',
          value: '60 cm',
        },
        {
          name: 'Depth',
          value: '41.5 cm',
        },
        {
          name: 'Height',
          value: '84 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '65 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '46.5 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '88 cm',
        },
        {
          name: 'Weight (Shipping)',
          value: '57 kg',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'HOTP',
      make: 'Hotpoint',
      model: 'WMAQF641P',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 2,
      upgrade_fee: 0,
      rrp: 272.18,
      article_id: 2147265318,
      uniqueId: '1/2147265318',
      appliance_category: 'Washing Machine',
      short_description: 'Hotpoint WMAQF641P Washing Machine',
      long_description: 'Hotpoint WMAQF641P Washing Machine White A+ 6 1400',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'WMAQF641P',
      supplier_id: 6684,
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },

        {
          name: 'Energy efficiency',
          value: null,
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      services: [
        {
          cat_num: 'DELRGB',
          charge_type: 1,
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 0,
          charge_customer: false,
        },
        {
          cat_num: 'INSRGB',
          charge_type: 2,
          status: Status.C,
          description: Description.Installation,
          price_net: 16.666666,
          price_gross: 20,
          charge_customer: true,
        },
        {
          cat_num: 'REMOVALRGBWM',
          charge_type: 3,
          status: Status.C,
          description: Description.Disposal,
          price_net: 10,
          price_gross: 12,
          charge_customer: true,
        },
      ],
      summary_specs: [
        'Baby cycle',
        'Eco Tech',
        'Anti-stain technology',
        'Woolmark platinum care',
        'Anti-allergy program',
        'Fast wash programs',
        'Selectable child lock',
        'Delay start',
      ],
      images: [
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/cf/4b/cf4bf570-94c1-4a2e-b48e-51ebbc7ec7a0.jpg',
        },
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/b5/43/b5433160-b5fd-4079-841f-fdec33f0fc02.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/c3/2c/c32c3fc3-a211-4af6-bf17-c17528aaa39c.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'Yes',
          compare: CompareType.BETTER,
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '540',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Hotpoint',
        },
        {
          name: 'ReleaseDate',
          value: 'Jan 20 2014 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1400',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '6',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Hotpoint WMAQF 641P washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+',
        },
        {
          name: 'Loading Capacity',
          value: '6 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '196 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '8643 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1400 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '58 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '80 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '80 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '52 liters',
        },
        {
          name: 'Programs Qty',
          value: '16',
        },
        {
          name: 'Safety Features',
          value: 'Child security, water overflow protection system',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 54 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '66 kg',
        },
        {
          name: 'Manufacturer Warranty',
          value: '1 year',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Program Time Details',
          value: '195 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Type',
          value: 'Digital',
        },
        {
          name: 'Special Programs & Options',
          value: `Quick wash, Woolmark Platinum Care, Baby, Super Wash,
            anti-allergy, pause option, daily 30', eco wash`,
        },
        {
          name: 'Features',
          value:
            'Ecotech, anti-stain system, variable temperature, spin speed selection',
        },
        {
          name: 'Exterior Features',
          value: 'White door',
        },
        {
          name: 'Compliant Standards',
          value: 'Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '1.05 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '54 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '64 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '59 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '89 cm',
        },
        {
          name: 'Warranty',
          value: '1 year',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'AMIC',
      make: 'Amica',
      model: 'WME612',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 3,
      upgrade_fee: 50,
      rrp: 219.79,
      article_id: 2146846204,
      uniqueId: '2/2146846204',
      appliance_category: 'Washing Machine',
      short_description: 'Amica WME612 Washing Machine',
      long_description: 'Amica WME612 Washing Machine White A++ 6 1200',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'WME612',
      supplier_id: 6684,
      services: [],
      summary_specs: [
        'Variable spin speed',
        'Delay timer',
        'Child lockable control panel',
        'Anti-crease function',
      ],
      key_features: [],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/c8/bf/c8bf5e01-41cf-441a-ac3a-2e4b1f045471.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
          compare: CompareType.EQUIVALENT,
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '470',
        },
        {
          name: 'Energy Efficiency',
          value: 'A++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Amica',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '6',
        },
        {
          name: 'Wash Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Amica WME612 washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A++',
        },
        {
          name: 'Loading Capacity',
          value: '6 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '173 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '9240 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '59 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '76 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '76 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Programs Qty',
          value: '23',
        },
        {
          name: 'Safety Features',
          value: 'ChildLock',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.9 kWh',
        },
        {
          name: 'Water Consumption per Cycle',
          value: '48 liters',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Plug Type',
          value: 'British',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 47 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '54 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton Eco',
        },
        {
          name: 'Door Opening Diameter',
          value: '45 cm',
        },
        {
          name: 'Program Time Details',
          value: '239 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Material',
          value: 'Stainless steel',
        },
        {
          name: 'Control Location',
          value: 'Front panel',
        },
        {
          name: 'Timer Settings Features',
          value:
            'Program ending audible signal, 3 hours auto shut-off delay, 6 hours auto shut-off delay, signal on/off, 9 hours auto shut-off delay',
        },
        {
          name: 'Indicators',
          value: 'Closed door indicator, child security indicator',
        },
        {
          name: 'Special Programs & Options',
          value: `Pre-wash, delicate, cotton eco, drain, skip spin, extra rinse,
            spin only, delicate 30°, anti-crease at the end of cycle, Auto clean,
            rinse, pause option, cotton 20 °C, Express 15', synthetic 40 °C,
            synthetic 60 °C, cotton 40 °C, cotton 30 °C, cotton 60 °C, cotton 90 °C,
            cotton eco 60 °C, cotton cold, synthetic cold, drum cleaning, quick 30', daily 45'`,
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'Directive 2009/125/EC, Directive 1015/2010/EU, Directive 2010/30/EU, Directive 1061/2010/EU, EN 60456, RoHS 2011/65/EU, LVD 2014/35/EU, Directive 2009/125/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.9 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Max Power Consumption',
          value: '1950 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '1 W',
        },
        {
          name: 'Rated Current',
          value: '13 A',
        },
        {
          name: 'Cord Length',
          value: '1.5 m',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '47 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'HOTP',
      make: 'Hotpoint',
      model: 'WMEUF722P',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 4,
      upgrade_fee: 30.01,
      rrp: 272.8,
      article_id: 2146902655,
      uniqueId: '3/2146902655',
      appliance_category: 'Washing Machine',
      short_description: 'Hotpoint WMEUF722P Washing Machine',
      long_description: 'Hotpoint WMEUF722P Washing Machine White A++ 7 1200',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'WMEUF722P',
      supplier_id: 6684,
      services: [],
      summary_specs: [],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/a7/36/a7363592-3cd5-4e22-a555-42eb7501173a.jpg',
        },
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '540',
        },
        {
          name: 'Energy Efficiency',
          value: 'A++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Hotpoint',
        },
        {
          name: 'ReleaseDate',
          value: 'Jun  1 2017 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '7',
        },
        {
          name: 'Wash Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Hotpoint WMEUF 722P UK washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A++',
        },
        {
          name: 'Loading Capacity',
          value: '7 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '198 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '10630 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '58 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '77 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '77 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Washer Drum Capacity',
          value: '52 liters',
        },
        {
          name: 'Washing Efficiency',
          value: 'Class A',
        },
        {
          name: 'Safety Features',
          value: 'Anti-foam control',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '1.08 kWh',
        },
        {
          name: 'Water Consumption per Cycle',
          value: '52.5 liters',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Plug Type',
          value: 'British',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 54 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '65.8 kg',
        },
        {
          name: 'Manufacturer Warranty',
          value: '1 year',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton Eco',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '205 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Control Location',
          value: 'Front panel',
        },
        {
          name: 'Indicators',
          value: 'Time remaining indicator, wash progress indicator',
        },
        {
          name: 'Type',
          value: 'Digital',
        },
        {
          name: 'Special Programs & Options',
          value: `Bed & bath, delicate, cotton, synthetics, shirts,
            Baby, Woolmark, anti-stain program, drain + spin, whites, drain,
            favorite, skip spin, extra rinse, rinse + spin, quick 60',
            wool 40°, rinse, cotton 20 °C, cotton eco 40 °C, cotton eco 60 °C,
            Anti Allergy Plus, quick 30'`,
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable front feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'Directive 2010/30/EC, Directive 1061/2010/EU, WEEE 2012/19/EU, EMC 2014/30/EU, LVD 2014/35/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '1.08 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '1850 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Rated Current',
          value: '13 A',
        },
        {
          name: 'Cord Length',
          value: '1.2 m',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '54 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Warranty',
          value: '1 year',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'INDE',
      make: 'Indesit',
      model: 'EWD71252W',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 5,
      upgrade_fee: 295,
      rrp: 249.99,
      article_id: 2147112660,
      uniqueId: '4/2147112660',
      appliance_category: 'Washing Machine',
      short_description: 'Indesit EWD71252W Washing Machine',
      long_description: 'Indesit EWD71252W Washing Machine White A++ 7 1200',
      selected: false,
      supplier_name: 'AO Retail',
      cat_num: 'EWD71252W',
      supplier_id: 6680,
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      services: [
        {
          cat_num: 'DELSTD',
          charge_type: 1,
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 0,
          charge_customer: false,
        },
        {
          cat_num: 'AOINDE',
          charge_type: 2,
          status: Status.C,
          description: Description.Installation,
          price_net: 16.658333,
          price_gross: 19.99,
          charge_customer: true,
        },
        {
          cat_num: 'REMAO',
          charge_type: 3,
          status: Status.C,
          description: Description.Disposal,
          price_net: 8.325,
          price_gross: 9.99,
          charge_customer: true,
        },
      ],
      summary_specs: [
        'With the Eco Time option there is no need to wait for a full load, this option is to use whenever you need to wash a smaller load and quickly',
        'Energy Saver option, on cotton, synthetic and jeans wash program, allows you to achieve optimal wash results with energy savings of up to 70% (compared to cotton wash cycles 30°C)',
        'Indesit offers a wide number of special programs to wash effectively different kinds of fabric according to your needs',
        'The sport cycles specifically designed by Indesit to take care of your sport garments',
        'You can delay the program for up to 24 hours according to your needs',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/19/96/1996e802-b229-4e07-8c6d-4e776675d320.jpg',
        },
        {
          text: 'Left-angle',
          url: 'https://cdn.cnetcontent.com/d8/7c/d87c1c38-8b70-47f4-b1cb-133ce40d9383.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/45/e0/45e0b648-6ccf-4553-97b3-55771ba9067d.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/65/6d/656d219b-0b1c-46c6-8ea5-8d229a0ee299.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/fc/b6/fcb6a161-ae16-4a69-8691-f37878fb303f.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '535',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Indesit',
        },
        {
          name: 'ReleaseDate',
          value: 'Oct  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '7',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Indesit Ecotime EWD 71252 W washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A++',
        },
        {
          name: 'Loading Capacity',
          value: '7 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '197 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '10600 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: '1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '60 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '75 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '75 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding (can be integrated)',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '52 liters',
        },
        {
          name: 'Programs Qty',
          value: '16',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '1.096 kWh',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 53.5 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '66.5 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Average Cycle Time',
          value: '205 minutes',
        },
        {
          name: 'Timer Settings Features',
          value: '24 hours start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '24 hours',
        },
        {
          name: 'Indicators',
          value: 'Wash progress indicator',
        },
        {
          name: 'Type',
          value: 'LED display',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Wool, jeans, outerwear, sports light, sports intensive, Zone 20°, Energy Saver option, TimeSaver',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '53.5 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '64.5 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '59 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '89 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'ZANU',
      make: 'Zanussi',
      model: 'ZWF81243',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 6,
      upgrade_fee: 99,
      rrp: 283.5,
      article_id: 2147158145,
      uniqueId: '5/2147158145',
      appliance_category: 'Washing Machine',
      short_description: 'Zanussi ZWF81243 Washing Machine',
      long_description: 'Zanussi ZWF81243 Washing Machine White A+++ 8 1200',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'ZWF81243',
      supplier_id: 6684,
      services: [],
      summary_specs: [
        'Saves you time, reducing energy and water consumption',
        'Wash your clothes in half the time',
        'The washing machine that runs whenever it suits you best',
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/fa/04/fa04df13-4924-40df-91f2-7ccb193162ee.jpg',
        },
        {
          text: 'Back',
          url: 'https://cdn.cnetcontent.com/31/9a/319a7bb5-dcf4-4ef2-953b-eacbb77ac2d3.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/fa/6b/fa6bc28e-249c-43b5-a15c-a063a09b372a.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/65/15/65156b13-ab61-4ff9-bf4d-e9746cb3d288.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '559',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Zanussi',
        },
        {
          name: 'ReleaseDate',
          value: 'Mar  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '8',
        },
        {
          name: 'Wash Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Zanussi LINDO100E ZWF81243WE washing machine - front loading - freestanding',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '8 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '190 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '9999 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '59 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '77 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '77 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Washer Drum Capacity',
          value: '54 liters',
        },
        {
          name: 'Program Optimization',
          value: 'Fuzzy Logic',
        },
        {
          name: 'Safety Features',
          value: 'ChildLock, Anti-flood protection',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '1.03 kWh',
        },
        {
          name: 'Water Consumption per Cycle',
          value: '48 liters',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.7 cm x 64.3 cm x 85.4 cm',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton Eco',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '5 min',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '210 min - washing - full load - 60 °C',
        },
        {
          name: 'Control Location',
          value: 'Front panel',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay, program ending audible signal, FlexiTimer',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '9 hours',
        },
        {
          name: 'Indicators',
          value:
            'Time remaining indicator, lock indicator, wash progress indicator',
        },
        {
          name: 'Type',
          value: 'Digital',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Quick wash, delicate, cotton, synthetics, dark garments, jeans, drain, Easy Iron, 20 min - 3 kg, rinse, Mix 20, Wool Plus, 30 min 30°, spin, cotton economy, AutoSense',
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'IPX4, Directive 2010/30/EC, Directive 2009/125/EC, Directive 1061/2010/EU, Directive 1015/2010/EC',
        },
        {
          name: 'Energy Consumption Details',
          value: '1.03 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '1850 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.48 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.48 W',
        },
        {
          name: 'Rated Current',
          value: '13 A',
        },
        {
          name: 'Cord Length',
          value: '1.4 m',
        },
        {
          name: 'Width',
          value: '59.7 cm',
        },
        {
          name: 'Depth',
          value: '64.3 cm',
        },
        {
          name: 'Height',
          value: '85.4 cm',
        },
        {
          name: 'Dimensions Details',
          value: 'Depth without door 60.7 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'ZANU',
      make: 'Zanussi',
      model: 'ZWF71340W',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 7,
      upgrade_fee: 55,
      rrp: 0,
      article_id: 2147173727,
      uniqueId: '6/2147173727',
      appliance_category: 'Washing Machine',
      short_description: 'Zanussi ZWF71340W Washing Machine',
      long_description: 'Zanussi ZWF71340W Washing Machine White A+++ 7 1300',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'ZWF71340W',
      supplier_id: 6684,
      services: [],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      summary_specs: [
        'Clean clothes in just 30 minutes',
        'Quick wash in 30 minutes - easy does it',
        'Always keeps the detergent dispenser clean',
        'The washing machine that runs whenever it suits you best',
        'Wash your clothes in half the time',
        'Get perfectly clean clothes, each and every wash load',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/cb/43/cb43905b-83c2-43a6-b149-ba9a1baae5b2.jpg',
        },
        {
          text: 'Back',
          url: 'https://cdn.cnetcontent.com/69/5b/695b1875-4d18-434e-88a0-bf51adbdab42.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/38/84/38841470-a573-4d3d-aec1-3b41da6e073a.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/e3/1e/e31e9b26-45fd-4ada-b882-3e6a423ed7f7.jpg',
        },
        {
          text: 'Left-angle',
          url: 'https://cdn.cnetcontent.com/03/c0/03c048e9-4a7f-4047-b92f-612f9decece9.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '514',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Zanussi',
        },
        {
          name: 'ReleaseDate',
          value: 'Mar  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'A',
        },
        {
          name: 'Spin Speed',
          value: '1300',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '7',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Zanussi LINDO100 ZWF71340W washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '7 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '171 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '9499 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1300 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '52%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '58 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '78 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '78 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washing Efficiency',
          value: 'Class A',
        },
        {
          name: 'Programs Qty',
          value: '14',
        },
        {
          name: 'Program Optimization',
          value: 'Fuzzy Logic',
        },
        {
          name: 'Safety Features',
          value: 'ChildLock, Anti-flood protection',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.92 kWh',
        },
        {
          name: 'Voltage',
          value: '230 - 240 V / 50 Hz',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '60 cm x 55.9 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '65.4 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '5 min',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '250 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Average Cycle Time',
          value: '250 minutes',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '9 hours',
        },
        {
          name: 'Special Programs & Options',
          value: `Quick wash, delicate, cold wash, cotton, synthetics, dark garments,
            hand wash/wool, jeans, quick 30, drain, Mini 30, extra rinse,
            Easy Iron, quick 20, rinse, pause option, Mix 20, Wool Plus,
            30 min 30°, 20' refresh, spin, cotton economy, TimeSaver`,
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'IPX4, Directive 2010/30/EC, Directive 2009/125/EC, Directive 1015/2010/EU, Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.92 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '2200 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.48 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.48 W',
        },
        {
          name: 'Rated Current',
          value: '13 A',
        },
        {
          name: 'Width',
          value: '60 cm',
        },
        {
          name: 'Depth',
          value: '55.9 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'INDE',
      make: 'Indesit',
      model: 'EWD81482W',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 8,
      upgrade_fee: 0,
      rrp: 277.55,
      article_id: 2147126935,
      uniqueId: '7/2147126935',
      appliance_category: 'Washing Machine',
      short_description: 'Indesit EWD81482W Washing Machine',
      long_description: 'Indesit EWD81482W Washing Machine White A++ 8 1400',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'EWD81482W',
      supplier_id: 6684,
      services: [],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      summary_specs: [
        'With the Eco Time option there is no need to wait for a full load, this option is to use whenever you need to wash a smaller load and quickly',
        'Energy Saver option, on cotton, synthetic and jeans wash program, allows you to achieve optimal wash results with energy savings of up to 70% (compared to cotton wash cycles 30°C)',
        'Indesit offers a wide number of special programs to wash effectively different kinds of fabric according to your needs',
        'The sport cycles specifically designed by Indesit to take care of your sport garments',
        'You can delay the program for up to 24 hours according to your needs',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/e2/29/e229cf2c-5ca2-4cbd-83ec-0628e4f9f9e6.jpg',
        },
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/c4/37/c4374bd7-7c68-4099-a02e-9e3acc17b02a.jpg',
        },
        {
          text: 'Left-angle',
          url: 'https://cdn.cnetcontent.com/9b/2e/9b2e2cef-0149-4e04-a803-956d1866d961.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/23/e2/23e2fb18-6335-4fbf-a38a-3d33fafdd104.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/ca/5e/ca5e8b01-2215-4f11-b75e-55696d238c5a.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '600',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Indesit',
        },
        {
          name: 'ReleaseDate',
          value: 'Jun  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1400',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '8',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Indesit Ecotime EWD 81482 W washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A++',
        },
        {
          name: 'Loading Capacity',
          value: '8 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '220 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '11594 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: '1400 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '50 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '78 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '78 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding (can be integrated)',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '62 liters',
        },
        {
          name: 'Programs Qty',
          value: '16',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '1.201 kWh',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 60 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '73.4 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Average Cycle Time',
          value: '215 minutes',
        },
        {
          name: 'Timer Settings Features',
          value: '24 hours start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '24 hours',
        },
        {
          name: 'Indicators',
          value: 'Wash progress indicator',
        },
        {
          name: 'Type',
          value: 'LED display',
        },
        {
          name: 'Special Programs & Options',
          value: 'Wool, sportswear, outerwear, Energy Saver option, TimeSaver',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '60 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '64.5 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '65.5 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '89 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'ZANU',
      make: 'Zanussi',
      model: 'ZWF81443W',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 9,
      upgrade_fee: 0,
      rrp: 295.56,
      article_id: 2147135799,
      uniqueId: '8/2147135799',
      appliance_category: 'Washing Machine',
      short_description: 'Zanussi ZWF81443W Washing Machine',
      long_description: 'Zanussi ZWF81443W Washing Machine White A+++ 8 1400',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'ZWF81443W',
      supplier_id: 6684,
      services: [
        {
          cat_num: 'DELRGB',
          charge_type: 1,
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 30.99,
          charge_customer: true,
        },
        {
          cat_num: 'INSRGB',
          charge_type: 2,
          status: Status.C,
          description: Description.Installation,
          price_net: 16.666666,
          price_gross: 20,
          charge_customer: true,
        },
        {
          cat_num: 'REMOVALRGBWM',
          charge_type: 3,
          status: Status.C,
          description: Description.Disposal,
          price_net: 10,
          price_gross: 12,
          charge_customer: true,
        },
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },

        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      summary_specs: [
        'Quick wash in 30 minutes - easy does it',
        'Always keeps the detergent dispenser clean',
        'The washing machine that runs whenever it suits you best',
        'Wash your clothes in half the time',
        'Get perfectly clean clothes, each and every wash load',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/ee/63/ee63be0a-f876-4902-bda2-37353c960fa6.jpg',
        },
        {
          text: 'Back',
          url: 'https://cdn.cnetcontent.com/69/03/69039418-59ce-4777-940e-eb32db340611.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/9c/3a/9c3aec14-b3e0-48b8-9505-f131676f565b.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/39/6f/396f03c7-e103-48bf-97e7-d8ce82fcaa7a.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/a2/c3/a2c3ccdb-4cc2-4201-bda9-ce8ae667f32d.jpg',
        },
        {
          text: 'Left-angle',
          url: 'https://cdn.cnetcontent.com/7e/30/7e307aaf-1eab-454f-bba7-6bd52607bc18.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '559',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Zanussi',
        },
        {
          name: 'ReleaseDate',
          value: 'Mar  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1400',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '8',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Zanussi LINDO100 ZWF81443W washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '8 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '190 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '9999 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1400 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '52%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '58 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '78 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '78 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Safety Features',
          value: 'Child security, Aqua Control',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.96 kWh',
        },
        {
          name: 'Voltage',
          value: '230 V',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '60 cm x 57.8 cm x 85 cm',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '5 min',
        },
        {
          name: 'Program Time Details',
          value: '244 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Features',
          value: 'GentleCare drum',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '20 hours',
        },
        {
          name: 'Indicators',
          value: 'Time remaining indicator',
        },
        {
          name: 'Type',
          value: 'LCD display',
        },
        {
          name: 'Special Programs & Options',
          value: `Quick wash, delicate, hand wash, easy care, hand wash/silk,
            color wash, drain + spin, hand wash/wool, jeans, cotton eco,
            drain, extra rinse, Easy Iron, 30 min - 3 kg, hot, Mix 20, 20'
            refresh, QuickStart 30'@30°, Down Wear, short option, AutoSense`,
        },
        {
          name: 'Compliant Standards',
          value: 'Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.96 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '2200 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.75 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.48 W',
        },
        {
          name: 'Rated Current',
          value: '10 A',
        },
        {
          name: 'Width',
          value: '60 cm',
        },
        {
          name: 'Depth',
          value: '57.8 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 24,
      manuf_code: 'BOSC',
      make: 'Bosch',
      model: 'WAW32450GB_WH',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 10,
      upgrade_fee: 0,
      rrp: 600,
      article_id: 2146926548,
      uniqueId: '9/2146926548',
      appliance_category: 'Washing Machine',
      short_description: 'Bosch WAW32450GB_WH Washing Machine',
      long_description: 'Bosch WAW32450GB_WH Washing Machine White A+++ 9 1600',
      selected: false,
      supplier_name: 'AO Retail',
      cat_num: 'WAW32450GB_WH',
      supplier_id: 6680,
      services: [],
      summary_specs: [
        'EcoSilence Drive: extremely energy-efficient and quiet in operation with an especially long life',
        'Energy efficiency class A+++',
        'Allergy+ : specially developed for the needs of allergy sufferers',
        'ActiveWater: reduces water consumption and costs thanks to the sensor-controlled, stepless automatic load adjustment system',
        'VarioPerfect: takes 65% less time or uses 50% less energy - delivers total flexibility',
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },

        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      images: [
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/00/65/006563b7-e11a-473e-9120-6c9b6b0e2449.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/af/7a/af7a7d40-474c-477f-9096-ac67b0ee433e.jpg',
        },
        {
          text: 'Ports / controls',
          url: 'https://cdn.cnetcontent.com/9a/f1/9af193de-0742-4142-a7f6-e211d8182a9e.jpg',
        },
        {
          text: 'Ports / controls',
          url: 'https://cdn.cnetcontent.com/43/9d/439d4926-2e30-4a22-b911-7f3b28e4e73e.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '590',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '848',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Bosch',
        },
        {
          name: 'ReleaseDate',
          value: 'May  1 2017 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'A',
        },
        {
          name: 'Spin Speed',
          value: '1600',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '9',
        },
        {
          name: 'Wash Efficiency',
          value: 'Not Specified',
        },
        {
          name: 'Width',
          value: '598',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Bosch Serie | 8 WAW32450GB washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '9 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '152 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '11220 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class A',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1552 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '44%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '47 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '73 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '73 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding (can be integrated)',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Washer Drum Capacity',
          value: '70 liters',
        },
        {
          name: 'Safety Features',
          value:
            'AquaStop leak protection, water protection system, ChildLock, anti-foam control',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.92 kWh',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Plug Type',
          value: 'British',
        },
        {
          name: 'Sound Package',
          value: 'EcoSilence Drive',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.8 cm x 59 cm x 84.8 cm',
        },
        {
          name: 'Weight',
          value: '82 kg',
        },
        {
          name: 'Warranty Details',
          value: '10-year motor warranty',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton + EcoPerfect',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '15 min',
        },
        {
          name: 'Installation Type',
          value: 'Built under',
        },
        {
          name: 'Door Opening Angle',
          value: '171 degrees',
        },
        {
          name: 'Door Opening Diameter',
          value: '32 cm',
        },
        {
          name: 'Door Hinge',
          value: 'Left',
        },
        {
          name: 'Vibration Reduction',
          value: 'Yes',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '275 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Features',
          value: 'waveDrum',
        },
        {
          name: 'Control Location',
          value: 'Front panel',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay, program ending audible signal',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '24 hours',
        },
        {
          name: 'Indicators',
          value:
            'End of cycle, time remaining indicator, wash progress indicator',
        },
        {
          name: 'Type',
          value: 'LED display',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Quick wash, pre-wash, wool, cotton, hand wash, delicate/silk, easy care, SpeedPerfect, dark garments, shirts, sportswear, whites, hygiene, cotton eco, drain, mixed load, skip spin, Easy Iron, rinse + spin, ecoPerfect, Super Quick 15, reduced ironing, pause option, Allergy Plus, Aquaplus, varioPerfect',
        },
        {
          name: 'Interior Light',
          value: 'Yes',
        },
        {
          name: 'Customizable Features',
          value: 'Left door hinge',
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value:
            'VDE, Directive 2010/30/EC, Directive 1015/2010/EU, Directive 1061/2010/EU, WEEE 2012/19/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.92 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Max Power Consumption',
          value: '2300 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.12 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.43 W',
        },
        {
          name: 'Rated Current',
          value: '10 A',
        },
        {
          name: 'Cord Length',
          value: '1.75 m',
        },
        {
          name: 'Width',
          value: '59.8 cm',
        },
        {
          name: 'Depth',
          value: '59 cm',
        },
        {
          name: 'Height',
          value: '84.8 cm',
        },
        {
          name: 'Dimensions Details',
          value: 'Depth with door open 90° 106.3 cm',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'HOTP',
      make: 'Hotpoint',
      model: 'RPD10657J',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 11,
      upgrade_fee: 0,
      rrp: 458.99,
      article_id: 2147136292,
      uniqueId: '10/2147136292',
      appliance_category: 'Washing Machine',
      short_description: 'Hotpoint RPD10657J Washing Machine',
      long_description: 'Hotpoint RPD10657J Washing Machine White A+++ 10 1600',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'RPD10657J',
      supplier_id: 6684,
      services: [],
      summary_specs: [
        'Direct injection',
        'Super silent',
        'Steam technology',
        'Anti-stain Turbo 45',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/04/0b/040bdd21-53bd-4e20-b42a-668f6fc2e61f.jpg',
        },
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/2f/3f/2f3fb8a9-178f-4725-a33b-84f4e5fcfdb3.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/ca/3d/ca3d8354-7336-47a3-b10e-633e637875c1.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/7a/2c/7a2c0a7a-53c5-4cbb-9e67-a9af73643791.jpg',
        },
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/ca/ec/caecf49f-2360-4662-8810-76009bf94862.jpg',
        },
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/36/87/3687f778-8262-4bc9-80ef-a17e7c44e4df.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/fa/62/fa62e079-b264-4f6d-a552-5bfcb84dfac5.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/81/31/8131b85d-d1a3-485f-ab6d-73a61ae5d1f4.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/5f/74/5f747ff1-b009-419c-8322-7b8bdf121585.jpg',
        },
      ],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },

        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '605',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '850',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Hotpoint',
        },
        {
          name: 'ReleaseDate',
          value: 'Mar  1 2015 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'A',
        },
        {
          name: 'Spin Speed',
          value: '1600',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '10',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '595',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Hotpoint Ultima S-Line RPD 10657 JX washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '10 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '190 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '12810 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class A',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1600 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '44%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '56 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '78 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '78 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '71 liters',
        },
        {
          name: 'Programs Qty',
          value: '16',
        },
        {
          name: 'Safety Features',
          value: 'Water overflow protection system, control lock, ChildLock',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.973 kWh',
        },
        {
          name: 'Sound Package',
          value: 'SuperSilent',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '59.5 cm x 60.5 cm x 85 cm',
        },
        {
          name: 'Weight',
          value: '75 kg',
        },
        {
          name: 'Manufacturer Warranty',
          value: '1 year',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '30 min',
        },
        {
          name: 'Program Time Details',
          value: '220 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Indicators',
          value:
            'Time remaining indicator, closed door indicator, wash progress',
        },
        {
          name: 'Type',
          value: 'LCD display',
        },
        {
          name: 'Special Programs & Options',
          value: `Daily wash, bed & bath, quick wash, wool, cotton,
            synthetics, Woolmark Platinum Care, dark garments,
            shirts, Baby, anti-stain program, drain + spin, whites, duvet,
            quick 30, drain, Super Wash, anti-allergy, color wash 40°, steam hygiene,
            rinse, pause option, cotton eco 40 °C, cotton eco 60 °C,
            Anti Allergy Plus, ultra delicate, Anti Allergy delicate 40°,
            Anti-stain Power 20°, Anti-stain Turbo 45°, mix 30'`,
        },
        {
          name: 'Compliant Standards',
          value:
            'BS 5733, Directive 2004/108/EC, Directive 2006/95/EC, Directive 1015/2010/EU, Directive 2012/19/EU, Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.973 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.5 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '8 W',
        },
        {
          name: 'Width',
          value: '59.5 cm',
        },
        {
          name: 'Depth',
          value: '60.5 cm',
        },
        {
          name: 'Height',
          value: '85 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '64 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '65 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '89 cm',
        },
        {
          name: 'Warranty',
          value: '1 year',
        },
      ],
    },
    {
      item_code: 'AW',
      warranty: 24,
      manuf_code: 'BOSC',
      make: 'BOSCH',
      model: 'WAW32560GB',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 12,
      upgrade_fee: 0,
      rrp: 808.03,
      article_id: 2147229481,
      uniqueId: '11/2147229481',
      appliance_category: 'Washing Machine',
      short_description: 'BOSCH WAW32560GB Washing Machine',
      long_description: 'BOSCH WAW32560GB Washing Machine White A+++ 9 1600',
      selected: false,
      supplier_name: 'RGB',
      cat_num: 'WAW32560GB',
      supplier_id: 6684,
      services: [],
      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W100 x D200 x H300 mm',
        },
        {
          name: 'Wash capacity',
          value: '1 kg',
        },
      ],
      summary_specs: [
        'EcoSilence Drive: extremely energy-efficient and quiet in operation',
        'Consumption indication: easy operation and indication of energy and water consumption',
        'AutoStain: removes the four most common stains',
        'Energy efficiency class A+++: more efficient',
        'DrumClean with reminder function: program for cleaning and maintaining the drum',
        'Cottons 60 Eco and Cottons 40 Eco: the most efficient programs in terms of combined energy and water consumption',
        'VarioPerfect: speed or energy efficiency with perfect wash performance every time',
        'ActiveWater: water management system',
        'AntiVibration design - for more stability and quietness',
        'Consumption indication: information about energy and water consumption',
        'Large LED display for program status indication, temperature selection, spin speed, remaining time',
        '24 h end time delay, stain selection and consumption indication',
        'Control dial with integrated On/Off mode',
        'Reload facility',
        'Drum interior light',
        'Self-cleaning detergent drawer',
        'WaveDrum: gentle and efficient washing',
        'Sound insulation by additional noise reduction material',
        'Child lock',
        'Buzzer',
      ],
      images: [
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/fe/eb/feebc34f-1636-4828-bde0-b36269913563.jpg',
        },
        {
          text: 'Right side',
          url: 'https://cdn.cnetcontent.com/de/65/de657192-67af-4087-aaf7-a7742b749e36.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/df/62/df6292ff-5625-4ee9-98d9-f220c05f4f0a.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '590',
        },
        {
          name: 'Drying Function',
          value: 'No',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '845',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Bosch',
        },
        {
          name: 'ReleaseDate',
          value: 'Jun  1 2014 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'A',
        },
        {
          name: 'Spin Speed',
          value: '1600',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '9',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Bosch Serie | 8 Logixx WAW32560GB washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++ -30%',
        },
        {
          name: 'Loading Capacity',
          value: '9 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '152 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '11220 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class A',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1552 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '44%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '47 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '73 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '73 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding (can be integrated)',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Washer Drum Capacity',
          value: '65 liters',
        },
        {
          name: 'Washing Efficiency',
          value: 'Class A',
        },
        {
          name: 'Safety Features',
          value: 'Child security, water protection system',
        },
        {
          name: 'Voltage',
          value: '220 - 240 V / 50 Hz',
        },
        {
          name: 'Plug Type',
          value: 'British',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '60 cm x 59 cm x 84.5 cm',
        },
        {
          name: 'Weight',
          value: '80 kg',
        },
        {
          name: 'Manufacturer Warranty',
          value: '2 years',
        },
        {
          name: 'Warranty Details',
          value: '10-year motor warranty',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton + EcoPerfect',
        },
        {
          name: 'Duration of the Left-on Mode',
          value: '15 min',
        },
        {
          name: 'Installation Type',
          value: 'Built under',
        },
        {
          name: 'Door Opening Angle',
          value: '171 degrees',
        },
        {
          name: 'Door Opening Diameter',
          value: '32 cm',
        },
        {
          name: 'Vibration Reduction',
          value: 'Yes',
        },
        {
          name: 'Program Time Details',
          value: '275 min - washing - full load - 60 °C',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Material',
          value: 'Stainless steel',
        },
        {
          name: 'Drum Features',
          value: 'waveDrum, drum light',
        },
        {
          name: 'Timer Settings Features',
          value:
            'Start timer delay, program ending audible signal, countdown timer',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '24 hours',
        },
        {
          name: 'Indicators',
          value:
            'End of cycle, time remaining indicator, water temperature indicator, wash progress indicator, drum cleaning indicator, consumption indicator',
        },
        {
          name: 'Type',
          value: 'LED display',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Pre-wash, wool, cold wash, cotton, hand wash, easy care, SpeedPerfect, shirts, sportswear, duvet, drain, mixed load, skip spin, Easy Iron, rinse + spin, ecoPerfect, Night Wash, Super Quick 15, delicate 30°, reduced ironing, pause option, Allergy Plus, auto stains removal, drum cleaning, Aquaplus, varioPerfect',
        },
        {
          name: 'Interior Light',
          value: 'Yes',
        },
        {
          name: 'Features',
          value:
            'EcoSilence Drive motor, VarioPerfect option, ActiveWater system, Aqua Plus, autoStain Removal System (ASR), reload facility, self-cleaning detergent drawer, AntiVibration Design, variable temperature, balance control, foam control, DrumClean with reminder function',
        },
        {
          name: 'Exterior Features',
          value:
            'White control panel, left hinged, white satin aluminum door rim',
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Compliant Standards',
          value: 'VDE, Directive 1061/2010/EU',
        },
        {
          name: 'Energy Consumption Details',
          value: '0.92 kWh - washing - full load - 60 °C',
        },
        {
          name: 'Max Power Consumption',
          value: '2300 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.12 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.43 W',
        },
        {
          name: 'Cord Length',
          value: '1.75 m',
        },
        {
          name: 'Width',
          value: '60 cm',
        },
        {
          name: 'Depth',
          value: '59 cm',
        },
        {
          name: 'Height',
          value: '84.5 cm',
        },
        {
          name: 'Weight (Shipping)',
          value: '81 kg',
        },
        {
          name: 'Warranty',
          value: '2 years',
        },
      ],
    },
  ],
};

export const mockTakenOffers = {
  offer: {
    offer_status: 'TAKEN',
    expected_delivery_date: '29/09/2020',
  },
  current_plan: {
    plan_number: '4MF0004740',
    dd_details: {
      sort_code: '****01',
      account_number: '******90',
      name: 'J Smith',
      nom_pay_day: '05',
      payment_token: 'VU700292801340540',
    },
  },
  contact_details: {
    title: 'DR',
    forename: 'WHIRLPRAWS',
    surname: 'WHIRLPRAWS',
  },
  delivery_address: {
    address_line_1: 'FLAT 1',
    address_line_2: '16 NETHERKIRKGATE',
    address_line_3: 'ABERDEEN',
    postal_code: 'AB10 1AU',
    country_code: 'GBR',
  },
  current_item: {
    make: 'Indesit',
    model: 'PWDE8128',
    colour: 'White',
    appliance_category: 'Washer Dryer',
  },
  replacement_offers: [
    {
      make: 'Indesit',
      model: 'IWDC6125',
      colour: 'White',
      selected: true,
      supplier_name: 'Indesit',
    },
  ],
};

export const mockOffersBespoke: Offers = {
  offer: {
    offer_status: OfferStatus.AVAILABLE,
    number_of_replacements: 6,
    number_of_upgrades: 6,
    upsell_flag: true,
    rrp_flag: true,
    outstanding_dd_amount: 99,
    outstanding_dd_count: 12,
  },
  current_plan: {
    client_code: '00351',
    client_group_code: '00296',
    plan_category: 'S',
    plan_number: 'ORB0000150',
    company_code: 'D',
    scheme_code: 'T3F',
    reference_number: '0005123',
    dd_amount: 8.99,

    dd_details: {
      sort_code: '****01',
      account_number: '******90',
      name: 'J Smith',
      nom_pay_day: '03',
      payment_token: 'VU700292801340540',
    },
  },
  contact_details: {
    forename: 'SHABA',
    surname: 'MORETON-AAAQ',
    person_gid: '3697141',
  },
  delivery_address: {
    address_line_1: '28 HEPPLESTONE CLOSE',
    address_line_2: 'LONDON',
    address_line_3: 'LONDON',
    postal_code: 'SW15 5DE',
    country_code: 'GBR',
  },
  person_owner_eid: '3697141',
  current_item: {
    make: 'Bosch',
    model: 'WAN28080GB',
    colour: 'Silver',
    short_description: 'Bosch WAN28080GB Washing Machine',
    long_description: 'Bosch WAN28080GB Washing Machine Silver A+++ 7 1400',
    images: [
      {
        text: '',
        url: 'https://validatorimages.azureedge.net/large/2147012039.jpg',
      },
    ],
    compare_specs: [
      {
        name: 'Bluetooth',
        value: 'No',
      },
      {
        name: 'Construction',
        value: 'Freestanding',
      },
      {
        name: 'Delay Timer',
        value: 'Yes',
      },
      {
        name: 'Depth',
        value: '550',
      },
      {
        name: 'Drying Function',
        value: 'No',
      },
      {
        name: 'Energy Efficiency',
        value: 'A+++',
      },
      {
        name: 'Height',
        value: '848',
      },
      {
        name: 'Loading',
        value: 'Front Loader',
      },
      {
        name: 'Make',
        value: 'Bosch',
      },
      {
        name: 'ReleaseDate',
        value: 'Jul  1 2016 12:00AM',
      },
      {
        name: 'Spin Efficiency',
        value: 'B',
      },
      {
        name: 'Spin Speed',
        value: '1400',
      },
      {
        name: 'Type',
        value: 'Washing machine',
      },
      {
        name: 'Wash Capacity',
        value: '7',
      },
      {
        name: 'Wash Efficiency',
        value: 'A',
      },
      {
        name: 'Width',
        value: '598',
      },
      {
        name: 'WiFi',
        value: 'No',
      },
    ],
    purchase_price: 300,
    appliance_category: 'Washing Machine',
  },
  replacement_offers: [
    {
      item_code: 'AW',
      warranty: 12,
      manuf_code: 'BEKO',
      make: 'BEKO',
      model: 'WTG620M2W',
      colour: 'White',
      offer_type: OfferType.UPGRADE,
      display_order: 1,
      upgrade_fee: 205,
      rrp: 215.42,
      article_id: 2146903247,
      appliance_category: 'Washing Machine',
      short_description: 'BEKO WTG620M2W Washing Machine',
      long_description: 'BEKO WTG620M2W Washing Machine White A+++ 6 1200',
      selected: true,
      supplier_name: 'RGB',
      cat_num: 'WTG620M2W',
      supplier_id: 6684,
      services: [
        {
          cat_num: 'DELRGB',
          charge_type: 1,
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 0,
          charge_customer: false,
        },
        {
          cat_num: 'INSRGB',
          charge_type: 2,
          status: Status.C,
          description: Description.Installation,
          price_net: 16.666666,
          price_gross: 20,
          charge_customer: true,
        },
        {
          cat_num: 'REMOVALRGBWM',
          charge_type: 3,
          status: Status.C,
          description: Description.Disposal,
          price_net: 10,
          price_gross: 12,
          charge_customer: true,
        },
      ],
      summary_specs: [
        'Slim depth',
        'Large porthole door',
        'Hand wash program',
        'Child safety lock',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/8d/7f/8d7f1746-55f1-441a-90fe-9f70ccac637a.jpg',
        },
      ],
      compare_specs: [
        {
          name: 'Bluetooth',
          value: 'No',
        },
        {
          name: 'Construction',
          value: 'Freestanding',
        },
        {
          name: 'Delay Timer',
          value: 'Yes',
        },
        {
          name: 'Depth',
          value: '415',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+++',
        },
        {
          name: 'Height',
          value: '840',
        },
        {
          name: 'Loading',
          value: 'Front Loader',
        },
        {
          name: 'Make',
          value: 'Beko',
        },
        {
          name: 'ReleaseDate',
          value: 'Aug 30 2017 12:00AM',
        },
        {
          name: 'Spin Efficiency',
          value: 'B',
        },
        {
          name: 'Spin Speed',
          value: '1200',
        },
        {
          name: 'Type',
          value: 'Washing machine',
        },
        {
          name: 'Wash Capacity',
          value: '6',
        },
        {
          name: 'Wash Efficiency',
          value: 'A',
        },
        {
          name: 'Width',
          value: '600',
        },
        {
          name: 'WiFi',
          value: 'No',
        },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value:
            'Beko WTG620M2 washing machine - front loading - freestanding - white',
        },
        {
          name: 'Product Type',
          value: 'Washing machine - front loading',
        },
        {
          name: 'Energy Class',
          value: 'Class A+++',
        },
        {
          name: 'Loading Capacity',
          value: '6 kg',
        },
        {
          name: 'Energy Consumption per Year',
          value: '152 kWh',
        },
        {
          name: 'Water Consumption per Year',
          value: '8799 liters',
        },
        {
          name: 'Spin Class',
          value: 'Class B',
        },
        {
          name: 'Spin Speed',
          value: 'Variable - 1200 rpm (max)',
        },
        {
          name: 'Residual Moisture',
          value: '53%',
        },
        {
          name: 'Noise Level (Washing)',
          value: '62 dB',
        },
        {
          name: 'Noise Level (Spinning)',
          value: '77 dB',
        },
        {
          name: 'Maximum Noise Level',
          value: '77 dB',
        },
        {
          name: 'Form Factor',
          value: 'Freestanding',
        },
        {
          name: 'Color',
          value: 'White',
        },
        {
          name: 'Control Type',
          value: 'Electronic',
        },
        {
          name: 'Washer Drum Capacity',
          value: '39 liters',
        },
        {
          name: 'Washing Efficiency',
          value: 'Class A',
        },
        {
          name: 'Programs Qty',
          value: '15',
        },
        {
          name: 'Safety Features',
          value:
            'Water overflow protection system, electromechanical door lock, ChildLock',
        },
        {
          name: 'Energy Consumption per Cycle',
          value: '0.78 kWh',
        },
        {
          name: 'Water Consumption per Cycle',
          value: '40 liters',
        },
        {
          name: 'Voltage',
          value: '230 V / 50 Hz',
        },
        {
          name: 'Dimensions (WxDxH)',
          value: '60 cm x 41.5 cm x 84 cm',
        },
        {
          name: 'Weight',
          value: '56 kg',
        },
        {
          name: 'Standard Washing Program',
          value: 'Cotton',
        },
        {
          name: 'Door Opening Angle',
          value: '170 degrees',
        },
        {
          name: 'Door Opening Diameter',
          value: '30 cm',
        },
        {
          name: 'Out-Of-Balance Detection',
          value: 'Yes',
        },
        {
          name: 'Exterior Color',
          value: 'White',
        },
        {
          name: 'Drum Material',
          value: 'Stainless steel',
        },
        {
          name: 'Average Cycle Time',
          value: '250 minutes',
        },
        {
          name: 'Timer Settings Features',
          value: 'Start timer delay',
        },
        {
          name: 'Maximum Start Timer Delay',
          value: '9 hours',
        },
        {
          name: 'Indicators',
          value: 'Wash progress indicator',
        },
        {
          name: 'Type',
          value: 'Digital',
        },
        {
          name: 'Special Programs & Options',
          value:
            'Daily wash, half-load, quick wash, pre-wash, cotton, synthetics, hand wash, dark garments, Baby, drain + spin, cotton eco, rinse hold, extra rinse, rinse, mix, drum cleaning',
        },
        {
          name: 'Wheels & Leveling',
          value: 'Adjustable feet',
        },
        {
          name: 'Water Connection',
          value: 'Cold',
        },
        {
          name: 'Max Power Consumption',
          value: '1550 W',
        },
        {
          name: 'Power Consumption Off-Mode',
          value: '0.25 W',
        },
        {
          name: 'Power Consumption Left-on Mode',
          value: '0.75 W',
        },
        {
          name: 'Rated Current',
          value: '10 A',
        },
        {
          name: 'Width',
          value: '60 cm',
        },
        {
          name: 'Depth',
          value: '41.5 cm',
        },
        {
          name: 'Height',
          value: '84 cm',
        },
        {
          name: 'Width (Shipping)',
          value: '65 cm',
        },
        {
          name: 'Depth (Shipping)',
          value: '46.5 cm',
        },
        {
          name: 'Height (Shipping)',
          value: '88 cm',
        },
        {
          name: 'Weight (Shipping)',
          value: '57 kg',
        },
      ],
    },
  ],
};

export const mockOffersCompare: Offers = {
  offer: {
    offer_status: OfferStatus.AVAILABLE,
    offerReference: '9d21f115-5be8-466d-8bad-117fa7c39701',
    expected_delivery_date: '17/06/2021',
    number_of_replacements: 15,
    number_of_upgrades: 8,
    upsell_flag: true,
    rrp_flag: false,
    outstanding_dd_amount: 0,
    outstanding_dd_count: 0,
  },
  current_plan: {
    client_code: '00351',
    client_group_code: '00296',
    plan_category: 'S',
    plan_number: 'AL30019624',
    company_code: 'D',
    scheme_code: 'AL3',
    reference_number: '0019624',
    dd_amount: 0,
  },
  contact_details: {
    title: 'MR',
    forename: 'ERSEL',
    surname: 'BICER',
    person_gid: '26166902',
    person_did: '',
    mobile_tel: '',
    home_tel: '',
    work_tel: '',
    contact_email: 'ERSEL_BICER@YAHOO.CO.UK',
  },
  delivery_address: {
    address_line_1: '55 FARNBOROUGH CRESCENT',
    address_line_2: 'SOUTH CROYDON',
    address_line_3: '',
    address_line_4: '',
    postal_code: 'CR2 8HA',
    country_code: 'GBR',
  },
  current_item: {
    make: 'Bosch',
    model: 'HBM13B150B',
    colour: 'Silver',
    short_description: 'Bosch HBM13B150B Oven',
    long_description: 'Bosch HBM13B150B Oven Silver Width 595 Height 888',
    images: [
      {
        text: '',
        url: 'https://validatorimages.azureedge.net/large/A2147413384I2147413384.jpg',
      },
    ],
    compare_specs: [
      { name: 'Alias', value: 'Not Specified' },
      { name: 'Bluetooth', value: 'No' },
      { name: 'Construction', value: 'Built in' },
      { name: 'Depth (mm)', value: 'N/A' },
      { name: 'FanOven', value: 'Yes' },
      { name: 'Height (mm)', value: '888' },
      { name: 'Main Oven Efficiency', value: 'A' },
      { name: 'Make', value: 'Bosch' },
      { name: 'Microwave Function', value: 'No' },
      { name: 'Microwave Power (W)', value: 'No Microwave Function' },
      { name: 'Multifunction', value: 'No' },
      { name: 'No of Functions', value: '0' },
      { name: 'Oven Type', value: 'Double' },
      { name: 'Self Clean', value: 'Enamel' },
      { name: 'Steam Function', value: 'No' },
      { name: 'Timer', value: 'Programmable' },
      { name: 'Top Oven Efficiency', value: 'A' },
      { name: 'Type', value: 'Oven Electric' },
      { name: 'Width (mm)', value: '595' },
      { name: 'WiFi', value: 'No' },
    ],
    purchase_price: 850,
    appliance_category: 'Oven',
  },
  replacement_offers: [
    {
      item_code: 'OV',
      key_features: [
        {
          name: 'Colour',
          value: 'Silver',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W888 x D888 x H888 mm',
        },
        {
          name: 'Place Settings',
          value: '12',
        },
      ],
      warranty: 24,
      manuf_code: 'BOSC',
      make: 'Bosch',
      model: 'MHA133BR0B_SS',
      colour: 'Silver',
      offer_type: OfferType.REPLACEMENT,
      display_order: 1,
      upgrade_fee: 0,
      rrp: 509,
      article_id: 2146719040,
      appliance_category: 'Oven',
      short_description: 'Bosch MHA133BR0B_SS Oven',
      long_description: 'Bosch MHA133BR0B_SS Oven Silver Width 594 Height 888',
      selected: false,
      supplier_name: 'AO Retail',
      cat_num: 'MHA133BR0B_SS',
      supplier_id: 6680,
      services: [
        {
          charge_type: 1,
          cat_num: 'DELSTD',
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 0,
          charge_customer: false,
        },
        {
          charge_type: 3,
          cat_num: 'REMSTD',
          status: Status.C,
          description: Description.Disposal,
          price_net: 8.325,
          price_gross: 9.99,
          charge_customer: true,
        },
        {
          charge_type: 2,
          cat_num: 'PREMINS',
          status: Status.C,
          description: Description.Installation,
          price_net: 66.658333,
          price_gross: 79.99,
          charge_customer: true,
        },
      ],
      summary_specs: [
        '3D Hotair: perfect results thanks to optimal distribution of heat on up to 3 levels simultaneously',
        'LED display control: easy-to-use thanks to clear time display',
        'EcoClean Direct: less cleaning effort thanks to a special coating which covers the rear wall of the lower oven',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/73/a2/73a2cfa4-0fa8-4c5b-a93e-fc76db8ebc93.jpg',
        },
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/0d/02/0d0259f0-6e1b-407f-8564-85b79378077b.jpg',
        },
        {
          text: 'Left-angle',
          url: 'https://cdn.cnetcontent.com/b8/54/b85480c5-bf27-4c12-bf82-a743ffe8a942.jpg',
        },
        {
          text: 'Close-up',
          url: 'https://cdn.cnetcontent.com/72/c4/72c46503-05ed-4159-9d2e-72dd8e1ce846.jpg',
        },
      ],
      compare_specs: [
        { name: 'Alias', value: 'Not Specified' },
        { name: 'Bluetooth', value: 'No' },
        { name: 'Construction', value: 'Built in' },
        { name: 'Depth', value: 'N/A' },
        { name: 'FanOven', value: 'Yes' },
        { name: 'Height', value: '888' },
        { name: 'Main Oven Efficiency', value: 'A' },
        { name: 'Make', value: 'Bosch' },
        { name: 'Microwave Function', value: 'No' },
        { name: 'Microwave Power (W)', value: 'No Microwave Function' },
        { name: 'Multifunction', value: 'No' },
        { name: 'No of Functions', value: '0' },
        { name: 'Oven Type', value: 'Double' },
        { name: 'Self Clean', value: 'Enamel' },
        { name: 'Steam Function', value: 'No' },
        { name: 'Timer', value: 'Programmable' },
        { name: 'Top Oven Efficiency', value: 'A' },
        { name: 'Type', value: 'Oven Electric' },
        { name: 'Width', value: '595' },
        { name: 'WiFi', value: 'No' },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value: 'Bosch Serie 2 MHA133BR0B - oven - built-in - stainless steel',
        },
        { name: 'Product Type', value: 'Oven - electric' },
        { name: 'Manufacturer', value: 'Bosch' },
        { name: 'Model', value: 'Bosch Serie 2 - MHA133BR0B' },
        { name: 'Form Factor', value: 'Built-in' },
        { name: 'Color', value: 'Stainless steel' },
        { name: 'Control Type', value: 'Touch sensitive, mechanical' },
        { name: 'Control Elements', value: 'Dial, touchpad' },
        { name: 'Self-Cleaning', value: 'Yes' },
        { name: 'Oven', value: 'Electric oven - 34 liters - glass door' },
        { name: '2nd Oven', value: 'Electric oven - 71 liters' },
        { name: 'Safety Features', value: 'Fan cooling system, ChildLock' },
        { name: 'Voltage', value: '220 - 240 V / 50 Hz' },
        { name: 'Dimensions (WxDxH)', value: '59.4 cm x 55 cm x 88.8 cm' },
        { name: 'Weight', value: '48.493 kg' },
        { name: 'Handle Design', value: 'Bar' },
        { name: 'Door Type', value: 'Glass door' },
        { name: 'Control Location', value: 'Front panel' },
        { name: 'Touch Controls', value: 'Yes' },
        { name: 'Timer', value: 'Yes' },
        { name: 'Type', value: 'LED display' },
        { name: 'Oven Type', value: 'Electric oven - 34 liters - Class B' },
        { name: 'Oven Rack Positions', value: '3' },
        { name: 'Oven Location', value: 'Upper' },
        { name: 'Door Open Type', value: 'Drop down door' },
        { name: 'Energy Efficiency Index', value: '120.3' },
        {
          name: 'Energy Consumption per Cycle (conventional mode)',
          value: '0.83 kWh',
        },
        { name: 'Oven Heating Modes Qty', value: '3' },
        { name: 'Oven Window', value: 'Yes' },
        { name: 'Oven Light', value: 'Yes' },
        { name: '2nd Oven Type', value: 'Electric oven - 71 liters - Class A' },
        { name: '2nd Oven Location', value: 'Lower' },
        { name: '2nd Oven Rack Positions', value: '5' },
        {
          name: 'Energy Consumption per Cycle (fan-forced convention mode)',
          value: '0.81 kWh',
        },
        { name: '2nd Oven Heating Modes Qty', value: '2' },
        { name: '2nd Oven Cooking Programs', value: '3D hot air, hot air eco' },
        { name: '2nd Oven Window', value: 'Yes' },
        { name: '2nd Oven Cavity Material', value: 'Enamel' },
        { name: 'Interior Coating', value: 'EcoClean enamel' },
        {
          name: 'Compliant Standards',
          value:
            'VDE, Directive 2010/30/EC, Directive 65/2014/EU, EN 60350-1, WEEE 2012/19/EU',
        },
        { name: 'Included Accessories', value: '3 x combination grid' },
        { name: 'Max Power Consumption', value: '4.8 kW' },
        { name: 'Rated Current', value: '25 A' },
        { name: 'Width', value: '59.4 cm' },
        { name: 'Depth', value: '55 cm' },
        { name: 'Height', value: '88.8 cm' },
        { name: 'Width (Shipping)', value: '69 cm' },
        { name: 'Depth (Shipping)', value: '66 cm' },
        { name: 'Height (Shipping)', value: '96 cm' },
        { name: 'Minimum Width', value: '56 cm' },
        { name: 'Minimum Depth', value: '55 cm' },
        { name: 'Minimum Height', value: '87.5 cm' },
      ],
    },

    {
      item_code: 'OV',
      warranty: 12,
      manuf_code: 'HOTP',
      make: 'Hotpoint',
      model: 'DD2540WH_WH',
      colour: 'White',
      offer_type: OfferType.REPLACEMENT,
      display_order: 3,
      upgrade_fee: 0,
      rrp: 288,
      article_id: 2147006389,
      appliance_category: 'Oven',
      short_description: 'Hotpoint DD2540WH_WH Oven',
      long_description: 'Hotpoint DD2540WH_WH Oven White Width 597 Height 887',
      selected: false,
      supplier_name: 'AO Retail',
      cat_num: 'DD2540WH_WH',
      supplier_id: 6680,
      services: [
        {
          charge_type: 1,
          cat_num: 'DELSTD',
          status: Status.F,
          description: Description.Delivery,
          price_net: 0,
          price_gross: 0,
          charge_customer: false,
        },
        {
          charge_type: 3,
          cat_num: 'REMSTD',
          status: Status.C,
          description: Description.Disposal,
          price_net: 8.325,
          price_gross: 9.99,
          charge_customer: true,
        },
        {
          charge_type: 2,
          cat_num: 'PREMINS',
          status: Status.C,
          description: Description.Installation,
          price_net: 66.658333,
          price_gross: 79.99,
          charge_customer: true,
        },
      ],
      summary_specs: [
        'Defrosting function',
        'Glass finish',
        'Air flow cooling fan',
        'Enamel cavity',
      ],
      images: [
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/28/55/28557045-86f0-437f-bd1f-9250ea53919b.jpg',
        },
        {
          text: 'Right-angle',
          url: 'https://cdn.cnetcontent.com/a5/c5/a5c54da0-a261-40cd-a306-e0e97e028e4b.jpg',
        },
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/37/5c/375c69d8-3bbb-4d73-aa7b-ef62e1404d11.jpg',
        },
        {
          text: 'Front',
          url: 'https://cdn.cnetcontent.com/78/0a/780a546c-a8ff-4b5c-bfc5-1b7fa6d55baf.jpg',
        },
      ],

      key_features: [
        {
          name: 'Colour',
          value: 'White',
        },
        {
          name: 'Energy Efficiency',
          value: 'A+',
        },
        {
          name: 'Measurements',
          value: 'W597 x D600 x H887 mm',
        },
        {
          name: 'Place Settings',
          value: '13',
        },
      ],
      compare_specs: [
        {
          name: 'Alias',
          value: 'DD2540BL, DD2540IX, DD2540WH',
          compare: CompareType.BETTER,
        },
        { name: 'Bluetooth', value: 'No' },
        { name: 'Construction', value: 'Built in' },
        { name: 'Depth', value: 'N/A', compare: CompareType.EQUIVALENT },
        { name: 'FanOven', value: 'Yes' },
        { name: 'Height', value: '887', compare: CompareType.WORSE },
        { name: 'Main Oven Efficiency', value: 'A' },
        { name: 'Make', value: 'Hotpoint', compare: CompareType.BETTER },
        { name: 'Microwave Function', value: 'No' },
        { name: 'Microwave Power (W)', value: 'No Microwave Function' },
        { name: 'Multifunction', value: 'No' },
        { name: 'No of Functions', value: '5', compare: CompareType.BETTER },
        { name: 'Oven Type', value: 'Double' },
        { name: 'Self Clean', value: 'Enamel' },
        { name: 'Steam Function', value: 'No' },
        { name: 'Timer', value: 'Programmable' },
        { name: 'Top Oven Efficiency', value: 'A' },
        { name: 'Type', value: 'Oven electric' },
        { name: 'Width', value: '597', compare: CompareType.BETTER },
        { name: 'WiFi', value: 'No' },
      ],
      detailed_specs: [
        {
          name: 'Product Description',
          value: 'Hotpoint Style DD2 540 WH - oven - built-in',
        },
        { name: 'Product Type', value: 'Oven - electric' },
        { name: 'Energy Class', value: 'Class A' },
        { name: 'Manufacturer', value: 'Hotpoint' },
        { name: 'Model', value: 'Hotpoint Style - DD2 540 WH' },
        { name: 'Total Net Oven Capacity', value: '116 liters' },
        { name: 'Oven Size', value: 'Large' },
        { name: 'Form Factor', value: 'Built-in' },
        { name: 'Control Type', value: 'Mechanical' },
        { name: 'Oven', value: 'Electric oven - 42 liters' },
        { name: '2nd Oven', value: 'Electric oven - 74 liters' },
        { name: 'Safety Features', value: 'Fan cooling system' },
        { name: 'Voltage', value: '230 - 240 V / 50 Hz' },
        { name: 'Dimensions (WxDxH)', value: '59.7 cm x 57.7 cm x 88.7 cm' },
        { name: 'Weight', value: '47 kg' },
        { name: 'Type', value: 'Digital' },
        { name: 'Oven Type', value: 'Electric oven - 42 liters - Class A' },
        { name: 'Door Open Type', value: 'Drop down door' },
        { name: 'Energy Efficiency Index', value: '105.8' },
        {
          name: 'Energy Consumption per Cycle (conventional mode)',
          value: '0.7 kWh',
        },
        { name: 'Oven Window', value: 'Yes' },
        { name: '2nd Oven Type', value: 'Electric oven - 74 liters - Class A' },
        {
          name: 'Energy Consumption per Cycle (fan-forced convention mode)',
          value: '0.91 kWh',
        },
        { name: '2nd Oven Cooking Programs', value: 'Convection' },
        { name: '2nd Oven Window', value: 'Yes' },
        { name: 'Compliant Standards', value: 'Directive 65/2014/EU' },
        { name: 'Max Power Consumption', value: '4.8 kW' },
        { name: 'Rated Current', value: '20 A' },
        { name: 'Width', value: '59.7 cm' },
        { name: 'Depth', value: '57.7 cm' },
        { name: 'Height', value: '88.7 cm' },
        { name: 'Minimum Width', value: '56.2 cm' },
        { name: 'Minimum Depth', value: '55 cm' },
        { name: 'Minimum Height', value: '88.2 cm' },
      ],
    },
  ],
};
